function __$styleInject (css, returnValue) {
  if (typeof document === 'undefined') {
    return returnValue;
  }
  css = css || '';
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  head.appendChild(style);
  
  if (style.styleSheet){
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
  return returnValue;
}

import React, { PureComponent } from 'react';
import { Provider, connect } from 'react-redux';
import PropTypes from 'prop-types';
import isMobile from 'is-mobile';
import fetch$1 from 'unfetch';
import appendQuery from 'append-query';
import cookie from 'cookie';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';
import { Debounce, Throttle } from 'lodash-decorators';
import { chunk, isArray, isBoolean, isEmpty, omitBy } from 'lodash';
import Clipboard from 'clipboard';
import Swipeable from 'react-swipeable';
import Mousetrap from 'mousetrap';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};









var asyncToGenerator = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};





var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();













var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var SET_API_KEY = 'SET_API_KEY';
var SET_GIF_DELAY = 'SET_GIF_DELAY';
var SET_GIF_LIMIT = 'SET_GIF_LIMIT';
var SET_GIF_OFFSET = 'SET_GIF_OFFSET';
var TOGGLE_IS_LETTERBOX = 'TOGGLE_IS_LETTERBOX';
var SET_IS_LETTERBOX = 'SET_IS_LETTERBOX';
var SET_IS_RANDOM = 'SET_IS_RANDOM';
var SET_IS_CUTOUT_HIDDEN = 'SET_IS_CUTOUT_HIDDEN';
var SET_IS_LOGO_HIDDEN = 'SET_IS_LOGO_HIDDEN';
var SET_IS_FORCE_GIFS = 'SET_IS_FORCE_GIFS';

var RANDOM_GIF_LIMIT = 100;
var DEFAULTS = {
    apiKey: '',
    gifDelay: 6000,
    gifLimit: 25,
    gifOffset: 0,
    isForceGifs: false,
    isLetterbox: true,
    isRandom: false,
    isLogoHidden: false,
    isCutoutHidden: isMobile()
};

var options = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULTS;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case SET_API_KEY:
            return _extends({}, state, { apiKey: action.apiKey });
        case SET_GIF_DELAY:
            return _extends({}, state, { gifDelay: action.delay });
        case SET_GIF_LIMIT:
            return _extends({}, state, { gifLimit: action.limit });
        case SET_GIF_OFFSET:
            return _extends({}, state, { gifOffset: action.offset });
        case SET_IS_LETTERBOX:
            return _extends({}, state, {
                isLetterbox: !!action.isLetterbox
            });
        case TOGGLE_IS_LETTERBOX:
            return _extends({}, state, {
                isLetterbox: !state.isLetterbox
            });
        case SET_IS_RANDOM:
            return _extends({}, state, {
                gifLimit: !action.isRandom ? DEFAULTS.gifLimit : RANDOM_GIF_LIMIT,
                isRandom: !!action.isRandom
            });
        case SET_IS_CUTOUT_HIDDEN:
            return _extends({}, state, { isCutoutHidden: action.isHidden });
        case SET_IS_LOGO_HIDDEN:
            return _extends({}, state, { isLogoHidden: action.isHidden });
        case SET_IS_FORCE_GIFS:
            return _extends({}, state, { isForceGifs: action.isForceGifs });
        default:
            return state;
    }
});

var setApiKey = function setApiKey(apiKey) {
    return { type: SET_API_KEY, apiKey: apiKey };
};
var setGifDelay = function setGifDelay(delay) {
    return { type: SET_GIF_DELAY, delay: delay };
};

var setGifOffset = function setGifOffset(offset) {
    return { type: SET_GIF_OFFSET, offset: offset };
};

var setIsLetterbox = function setIsLetterbox(isLetterbox) {
    return { type: SET_IS_LETTERBOX, isLetterbox: isLetterbox };
};
var setIsRandom = function setIsRandom(isRandom) {
    return { type: SET_IS_RANDOM, isRandom: isRandom };
};
var setIsCutoutHidden = function setIsCutoutHidden(isHidden) {
    return { type: SET_IS_CUTOUT_HIDDEN, isHidden: isHidden };
};
var setIsLogoHidden = function setIsLogoHidden(isHidden) {
    return { type: SET_IS_LOGO_HIDDEN, isHidden: isHidden };
};
var setIsForceGifs = function setIsForceGifs(isForceGifs) {
    return { type: SET_IS_FORCE_GIFS, isForceGifs: isForceGifs };
};

var getApiKey = function getApiKey(state) {
    return state.apiKey;
};
var getGifDelay = function getGifDelay(state) {
    return state.gifDelay;
};
var getGifLimit = function getGifLimit(state) {
    return state.gifLimit;
};
var getGifOffset = function getGifOffset(state) {
    return state.gifOffset;
};
var getIsLetterbox = function getIsLetterbox(state) {
    return state.isLetterbox;
};
var getIsRandom = function getIsRandom(state) {
    return state.isRandom;
};
var getIsCutoutHidden = function getIsCutoutHidden(state) {
    return state.isCutoutHidden;
};
var getIsForceGifs = function getIsForceGifs(state) {
    return state.isForceGifs;
};
var getIsLogoHidden = function getIsLogoHidden(state) {
    return state.isCutoutHidden ? false : state.isLogoHidden;
};

var apiUrl = 'https://api.giphy.com';

var getResults = function getResults(url, options) {
    return fetch$1(url, options).then(checkStatus).then(function (response) {
        return response.json();
    }).catch(function (error) {
        return console.log(error);
    });
};

var checkStatus = function checkStatus(res) {
    var status = res.status,
        ok = res.ok;

    if (status === 204) {
        return ok;
    }
    if (status >= 200 && status < 300) {
        return res;
    }

    return res.json();
};

var fetchTrendingGifs = function fetchTrendingGifs(page, apiKey, limit, offset) {
    return getResults(appendQuery(apiUrl + '/v1/gifs/trending', {
        api_key: apiKey,
        offset: page * limit + offset,
        limit: limit
    }));
};

var fetchChannelData = function fetchChannelData(channelName, apiKey) {
    var isChannelId = !isNaN(channelName);
    var formattedName = channelName.indexOf('@') === 0 ? channelName.substr(1) : channelName;

    if (isChannelId) {
        return getResults(appendQuery(apiUrl + '/v1/channels/' + formattedName, {
            api_key: apiKey
        })).then(function (_ref) {
            var data = _ref.data;
            return data;
        });
    }
    return getResults(appendQuery(apiUrl + '/v1/channels', {
        api_key: apiKey,
        search: formattedName
    })).then(function (results) {
        return results.data ? results.data.results[0] : null;
    });
};

var fetchChannelChildren = function fetchChannelChildren(channelId, apiKey) {
    return getResults(appendQuery(apiUrl + '/v1/channels/' + channelId + '/children', {
        api_key: apiKey
    }));
};

var fetchChannelGifs = function fetchChannelGifs(channelId, page, apiKey, limit) {
    var offset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    return getResults(appendQuery(apiUrl + '/v1/channels/' + channelId + '/gifs', {
        api_key: apiKey,
        offset: page * limit + offset,
        limit: limit
    }));
};

var fetchSearchGifs = function fetchSearchGifs(search, page, apiKey, limit) {
    var offset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

    if (search.toLowerCase() === 'trending') {
        return fetchTrendingGifs(page, apiKey, limit, offset);
    }

    return getResults(appendQuery(apiUrl + '/v1/gifs/search', {
        api_key: apiKey,
        q: search,
        offset: page * limit + offset,
        limit: limit
    }));
};

var fetchGifsById = function fetchGifsById(gifIds, apiKey) {
    return getResults(appendQuery(apiUrl + '/v1/gifs', {
        api_key: apiKey,
        ids: gifIds.join(',')
    }));
};

var getPagination = function getPagination(pages, index, gifLimit) {
    var pageIndex = Math.floor(index / gifLimit);
    var gifIndex = index - pageIndex * gifLimit;
    var page = pages[pageIndex] || [];
    var nextPage = pages.length >= pageIndex ? pages[pageIndex + 1] : null;
    var previousPage = pageIndex > 0 ? pages[pageIndex - 1] : null;
    var currentGif = page.length ? page[gifIndex] : null;
    var nextGif = page[gifIndex + 1] || (nextPage ? nextPage[0] : null);
    var previousGif = page[gifIndex - 1] || (previousPage ? previousPage[previousPage.length - 1] : null);
    return {
        currentIndex: index,
        currentGif: currentGif,
        nextGif: nextGif,
        previousGif: previousGif
    };
};

var RESET_GIFS = 'RESET_GIFS';
var SET_GIFS = 'SET_GIFS';
var SET_GIFS_TOTAL = 'SET_GIFS_TOTAL';
var SET_GIFS_FETCHING = 'SET_GIFS_FETCHING';
var SET_GIFS_CURRENT = 'SET_GIFS_CURRENT';
var SET_GIFS_FULLY_LOADED = 'SET_GIFS_FULLY_LOADED';
var SET_GIFS_LETTERBOX = 'SET_GIFS_LETTERBOX';

var DEFAULTS$1 = {
    pages: {},
    gifs: [],
    currentIndex: 0,
    currentGif: null,
    nextGif: null,
    previousGif: null,
    total: 0,
    isFetching: false,
    isFullyLoaded: false,
    meta: {}
};

var gifs = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULTS$1;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case SET_GIFS:
            var pages = _extends({}, state.pages);
            pages[action.page] = action.data;

            var allGifs = [];
            Object.keys(pages).forEach(function (page) {
                allGifs = allGifs.concat([].concat(toConsumableArray(pages[page])));
            });

            return _extends({}, state, {
                pages: pages,
                gifs: allGifs,
                isFetching: false,
                meta: action.meta
            });
        case SET_GIFS_TOTAL:
            return _extends({}, state, { total: action.total });
        case SET_GIFS_FETCHING:
            return _extends({}, state, { isFetching: action.isFetching });
        case SET_GIFS_CURRENT:
            return _extends({}, state, getPagination(state.pages, action.index, action.limit));
        case SET_GIFS_FULLY_LOADED:
            return _extends({}, state, { isFullyLoaded: action.isComplete });
        case SET_GIFS_LETTERBOX:
            return _extends({}, state, { isLetterbox: !!action.isLetterbox });
        case RESET_GIFS:
            return _extends({}, state, DEFAULTS$1);
        default:
            return state;
    }
});

var resetGifs = function resetGifs() {
    return { type: RESET_GIFS };
};
var setGifs = function setGifs(data, page, meta) {
    return { type: SET_GIFS, data: data, page: page, meta: meta };
};
var setGifsTotal = function setGifsTotal(total) {
    return { type: SET_GIFS_TOTAL, total: total };
};
var setGifsFetching = function setGifsFetching(isFetching) {
    return { type: SET_GIFS_FETCHING, isFetching: isFetching };
};
var setGifsCurrentIndex = function setGifsCurrentIndex(index, limit) {
    return { type: SET_GIFS_CURRENT, index: index, limit: limit };
};
var setGifsFullyLoaded = function setGifsFullyLoaded(isComplete) {
    return { type: SET_GIFS_FULLY_LOADED, isComplete: isComplete };
};

var getGifs = function getGifs(state) {
    return state.gifs;
};
var getPages = function getPages(state) {
    return state.pages;
};
var getTotalGifs = function getTotalGifs(state) {
    return state.total;
};
var getMeta = function getMeta(state) {
    return state.meta;
};

var getCurrentIndex = function getCurrentIndex(state) {
    return state.currentIndex;
};
var getCurrentGif = function getCurrentGif(state) {
    return state.currentGif;
};
var getNextGif = function getNextGif(state) {
    return state.nextGif;
};
var getPreviousGif = function getPreviousGif(state) {
    return state.previousGif;
};
var getIsFullyLoaded = function getIsFullyLoaded(state) {
    return state.isFullyLoaded;
};

var SET_CHANNELS = 'SET_CHANNELS';
var SET_CURRENT_CHANNEL = 'SET_CURRENT_CHANNEL';

var DEFAULTS$2 = {
    channels: [],
    currentIndex: 0,
    currentChannel: {}
};

var channels = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULTS$2;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case SET_CHANNELS:
            return _extends({}, state, {
                channels: action.channels
            });
        case SET_CURRENT_CHANNEL:
            return _extends({}, state, {
                currentChannel: state.channels[action.index],
                currentIndex: action.index
            });
        default:
            return state;
    }
});

var setChannels = function setChannels(channels) {
    return { type: SET_CHANNELS, channels: channels };
};
var setCurrentChannel = function setCurrentChannel(index) {
    return { type: SET_CURRENT_CHANNEL, index: index };
};

var getChannels = function getChannels(state) {
    return state.channels;
};
var getCurrentChannel = function getCurrentChannel(state) {
    return state.currentChannel;
};
var getCurrentChannelIndex = function getCurrentChannelIndex(state) {
    return state.currentIndex;
};

var SET_SWIPE_HORIZONTAL = 'SET_SWIPE_HORIZONTAL';
var SET_SWIPE_VERTICAL = 'SET_SWIPE_VERTICAL';
var SET_IS_SWIPED = 'SET_IS_SWIPED';
var RESET_SWIPE = 'RESET_SWIPE';

var DEFAULTS$3 = {
    x: 0,
    y: 0,
    progress: 0,
    previewImage: '',
    previewLabel: '',
    isVertical: false,
    isSwiping: false,
    isSwiped: false
};

var swiping = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULTS$3;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case SET_SWIPE_HORIZONTAL:
            return _extends({}, state, {
                x: action.x,
                y: 0,
                progress: Math.abs(action.x),
                previewImage: action.preview || '',
                previewLabel: action.label || '',
                isVertical: false,
                isSwiping: true
            });
        case SET_SWIPE_VERTICAL:
            return _extends({}, state, {
                x: 0,
                y: action.y,
                progress: Math.abs(action.y),
                previewImage: action.preview || '',
                previewLabel: action.label || '',
                isVertical: true,
                isSwiping: true
            });
        case SET_IS_SWIPED:
            return _extends({}, state, {
                x: action.x,
                y: action.y,
                isSwiped: true
            });
        case RESET_SWIPE:
            return _extends({}, state, DEFAULTS$3);
        default:
            return state;
    }
});

var setSwipeHorizontal = function setSwipeHorizontal(x, preview, label) {
    return { type: SET_SWIPE_HORIZONTAL, x: x, preview: preview, label: label };
};
var setSwipeVertical = function setSwipeVertical(y, preview, label) {
    return { type: SET_SWIPE_VERTICAL, y: y, preview: preview, label: label };
};
var setIsSwiped = function setIsSwiped() {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return { type: SET_IS_SWIPED, x: x, y: y };
};
var resetSwipe = function resetSwipe() {
    return { type: RESET_SWIPE };
};

var getSwipeX = function getSwipeX(state) {
    return state.x;
};
var getSwipeY = function getSwipeY(state) {
    return state.y;
};
var getSwipeProgress = function getSwipeProgress(state) {
    return state.progress;
};
var getSwipePreview = function getSwipePreview(state) {
    return state.previewImage;
};
var getSwipeLabel = function getSwipeLabel(state) {
    return state.previewLabel;
};
var getIsVertical = function getIsVertical(state) {
    return state.isVertical;
};
var getIsSwiping = function getIsSwiping(state) {
    return state.isSwiping;
};
var getIsSwiped = function getIsSwiped(state) {
    return state.isSwiped;
};

// const PREFIX = 'giphytv-'
var SESSION = {};

var setItem = function setItem(item, value) {
    SESSION[item] = value;
};

var getItem = function getItem(item) {
    return SESSION[item] || null;
};

var getGifObject = function getGifObject(gif, rendition) {
    if (gif && gif.images && gif.images[rendition]) {
        return gif.images[rendition];
    }
    return {};
};

/**
 * GIF Extract - Data: Utility function which will return
 * a GIF rendition data object.
 *
 * @param {Object} gif GIF data object.
 * @param {String} [rendition=original] GIF rendition to return.
 * @return {Object} GIF rendition data object.
 * @example
 *     getData({}, 'fixed_height') // returns fixed_height rendition
 */
function getData(gif) {
    var rendition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'original';

    return getGifObject(gif, rendition);
}

/**
 * GIF Extract - Url: Utility function which will return
 * a GIF rendition url.
 *
 * @param {Object} gif GIF data object.
 * @param {String} [rendition=original] GIF rendition to return.
 * @return {Object} GIF rendition image url.
 * @example
 *     getUrl({}, 'fixed_height') // returns fixed_height gif url
 */
function getUrl(gif) {
    var rendition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'original';
    var useWebp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var gifObject = getGifObject(gif, rendition);
    return (useWebp ? gifObject.webp : gifObject.url) || '';
}

/**
 * GIF Extract - MP4: Utility function which will return
 * a GIF rendition mp4 url.
 *
 * @param {Object} gif GIF data object.
 * @param {String} [rendition=original] GIF rendition to return.
 * @return {Object} GIF rendition mp4 url.
 * @example
 *     getMp4({}, 'fixed_height') // returns fixed_height gif url
 */




var findBestVideo = function findBestVideo(_ref, targetWidth, targetHeight) {
    var images = _ref.images;

    var targetSize = Math.max(targetWidth, targetHeight);
    var largest = null;

    for (var key in images) {
        var rendition = images[key];

        if (!rendition || !rendition.mp4 || key.indexOf('downsized') > -1) continue;

        var _images$key = images[key],
            width = _images$key.width,
            height = _images$key.height,
            mp4 = _images$key.mp4;

        var renditionWidth = parseInt(width || 0);
        var renditionHeight = parseInt(height || 0);
        var size = Math.max(renditionWidth, renditionHeight);

        if (!largest || size > largest.size) {
            largest = { size: size, mp4: mp4

                // if the size of this rendition matches
                // out target criteria, then we're all done
            };if (targetSize && size >= targetSize) {
                break;
            }
        }
    }

    return largest ? largest.mp4 : '';
};

var getPreview = function getPreview(gif) {
    return gif ? getUrl(gif, gif.is_sticker ? 'original' : 'fixed_width_still') : '';
};

var randomize = function (a) {
    for (var i = a.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));var _ref = [a[j], a[i]];
        a[i] = _ref[0];
        a[j] = _ref[1];
    }
};

var urlRE = RegExp(
//
// Regular Expression for URL validation
//
// Author: Diego Perini
// Updated: 2010/12/05
// License: MIT
//
// Copyright (c) 2010-2013 Diego Perini (http://www.iport.it)
//
// Permission is hereby granted, free of charge, to any person
// obtaining a copy of this software and associated documentation
// files (the "Software"), to deal in the Software without
// restriction, including without limitation the rights to use,
// copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the
// Software is furnished to do so, subject to the following
// conditions:
//
// The above copyright notice and this permission notice shall be
// included in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
// OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
// HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
// WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
// FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
// OTHER DEALINGS IN THE SOFTWARE.
//
'^' + '(' +
// protocol identifier
'(?:(?:https?:)?//)?' +
// user:pass authentication
'(?:\\S+(?::\\S*)?@)?' + '(?:' +
// IP address exclusion
// private & local networks
'(?!(?:10|127)(?:\\.\\d{1,3}){3})' + '(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})' + '(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})' +
// IP address dotted notation octets
// excludes loopback network 0.0.0.0
// excludes reserved space >= 224.0.0.0
// excludes network & broacast addresses
// (first & last IP address of each class)
'(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])' + '(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}' + '(?:\\.(?:1\\d\\d|2[0-4]\\d|25[0-4]|[1-9]\\d?))' + '|' +
// host name
'(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)' +
// domain name
'(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*' +
// TLD identifier
'(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))' +
// TLD may end with dot
'\\.?' + ')' +
// port number
'(?::\\d{2,5})?' +
// resource path
'(?:[/?#][^\\s\\?#]*)?' + ')' + '(?:\\?{0,1})' + '(?:\\S*)?' + '$', 'i');

var validate = function validate(url) {
    return urlRE.exec(url);
};



var removeProtocol = function removeProtocol(url) {
    var pretty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return '' + (pretty ? '' : '//') + url.replace(/.*?:\/\//g, '');
};

var gifToId = function (gifString) {
    var chunks = validate(gifString);

    if (chunks && chunks.length > 1) {
        var id = chunks[1].split('?')[0].split('-').slice(-1)[0];

        if (id.indexOf('/') > -1) {
            var subs = id.split('/');
            return subs[subs.length - 2];
        }

        return id;
    }

    return gifString;
};

var global$1 = typeof global !== "undefined" ? global :
            typeof self !== "undefined" ? self :
            typeof window !== "undefined" ? window : {};

var DEBUG = 0;
var INFO = 1;
var WARN = 2;
var ERROR = 3;

var Logger = {
    ENABLED: global$1.DEBUG || global$1.location && (location.href.indexOf('http://localhost') === 0 || location.search.indexOf('debug=true') !== -1),
    LEVEL: 0,
    debug: function debug() {
        if (Logger.ENABLED && Logger.LEVEL <= DEBUG) {
            var _console;

            (_console = console).debug.apply(_console, arguments); // eslint-disable-line no-console
        }
    },

    info: function info() {
        if (Logger.ENABLED && Logger.LEVEL <= INFO) {
            var _console2;

            (_console2 = console).info.apply(_console2, arguments); // eslint-disable-line no-console
        }
    },

    warn: function warn() {
        if (Logger.ENABLED && Logger.LEVEL <= WARN) {
            var _console3;

            (_console3 = console).warn.apply(_console3, arguments); // eslint-disable-line no-console
        }
    },
    error: function error() {
        if (Logger.ENABLED && Logger.LEVEL <= ERROR) {
            var _console4;

            (_console4 = console).error.apply(_console4, arguments); // eslint-disable-line no-console
        }
    }
};

var _mapAction;

if (!global$1.ga) {
    var s = document.createElement('script');
    s.src = 'https://www.google-analytics.com/analytics.js';
    document.head.appendChild(s);
    // ga snippet
    global$1.ga = global$1.ga || function () {
        (ga.q = ga.q || []).push(arguments); // eslint-disable-line no-undef
    };
    ga.l = +new Date(); // eslint-disable-line no-undef
    global$1.ga('create', 'UA-38174542-1', 'auto');
}

// if the action matches these, it'll fire of ga
var GA_ACTIONS = {
    CLICK_THROUGH: 'Click Through',
    SHARE: 'Share',
    FAVORITE: 'Favorite',
    CHANGE_CHANNEL: 'Change Channel'
};
var isGAAction = function isGAAction(action) {
    return Object.values(GA_ACTIONS).indexOf(action) !== -1;
};
var ACTIONS = _extends({}, GA_ACTIONS, {
    GIF_SHOWN: 'Gif Shown'
    // ui events aren't listed, but they could be
});

var gaEvent = function gaEvent(_ref) {
    var _ref$category = _ref.category,
        category = _ref$category === undefined ? 'GIPHY TV' : _ref$category,
        action = _ref.action,
        label = _ref.label;

    global$1.ga('send', 'event', category, action, label);
};

// Pingback
var pingbackUrl = 'https://pingback.giphy.com/pingback?apikey=l0HlIwPWyBBUDAUgM';

var defaultEvent = { event_type: 'GIPHY_TV', referrer: location.href };

var mapAction = (_mapAction = {}, defineProperty(_mapAction, ACTIONS.FAVORITE, 'FAVORITE'), defineProperty(_mapAction, ACTIONS.GIF_SHOWN, 'SEEN'), _mapAction);
var createPingbackEvent = function createPingbackEvent(_ref2) {
    var action = _ref2.action,
        data = _ref2.data,
        response_id = _ref2.response_id,
        gif_id = _ref2.gif_id,
        _ref2$attributes = _ref2.attributes,
        attributes = _ref2$attributes === undefined ? [] : _ref2$attributes;

    var type = mapAction[action] ? mapAction[action] : 'CLICK';
    if (type === 'CLICK') {
        var attribueKey = 'ui';
        // all other events are ui besides the below
        switch (action) {
            case ACTIONS.SHARE:
                attribueKey = 'share';
                break;
            case ACTIONS.CHANGE_CHANNEL:
                attribueKey = 'change_channel';
        }
        // if there's no data, then use the action name (e.g. ui events)
        attributes.push({ key: attribueKey, value: data || action });
    }
    return _extends({}, defaultEvent, {
        response_id: response_id,
        actions: [{
            action_type: type,
            ts: Date.now(),
            gif_id: gif_id,
            attributes: attributes
        }]
    });
};

var pingbackEvent = function pingbackEvent(event) {
    var _ref3 = global$1.USER || {},
        _ref3$id = _ref3.id,
        userId = _ref3$id === undefined ? '' : _ref3$id;

    var _cookie$parse = cookie.parse(document.cookie),
        user_id = _cookie$parse.giphy_pbid;

    var user = {
        user_id: user_id,
        logged_in_user_id: String(userId)
    };

    return fetch(pingbackUrl, {
        method: 'POST',
        body: JSON.stringify({
            sessions: [{
                session_id: '',
                user: user,
                events: [event]
            }]
        }),
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

var ORIGIN = document && document.location && document.location.origin;
var IS_GIPHY = ORIGIN.indexOf('giphy.com') > -1;

// sometimes the featured gif was coming back as an object
// instead of string... this is accounting for that
var featuredGifUrl = function featuredGifUrl(gif) {
    return (typeof gif === 'undefined' ? 'undefined' : _typeof(gif)) === 'object' ? getUrl(gif, 'fixed_width') : 'https://media.giphy.com/media/' + gif + '/200.gif';
};

var popoutUrl = function popoutUrl(term) {
    var isSearch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return (IS_GIPHY ? ORIGIN : 'https://giphy.com') + '/tv' + (isSearch ? '/search' : '') + '/' + term;
};

var getSearchTermData = function getSearchTermData(term, results) {
    var _results = slicedToArray(results, 1),
        gif = _results[0];

    var formattedTerm = term.indexOf('#') === 0 ? term.substr(1) : term;
    formattedTerm = formattedTerm.indexOf('@') === 0 ? formattedTerm.substr(1) : formattedTerm;
    return {
        term: formattedTerm,
        displayName: '#' + (formattedTerm.indexOf('giphy') === 0 ? formattedTerm.substr(5) : formattedTerm),
        previewImage: gif ? getUrl(gif, 'fixed_width') : '',
        popoutUrl: popoutUrl(formattedTerm, true),
        isSearch: true
    };
};

var getChannelData = function getChannelData(_ref) {
    var display_name = _ref.display_name,
        id = _ref.id,
        slug = _ref.slug,
        user = _ref.user,
        featured_gif = _ref.featured_gif;
    return {
        term: id,
        displayName: display_name,
        previewImage: featured_gif ? featuredGifUrl(featured_gif) : user ? user.avatar : '',
        popoutUrl: popoutUrl(slug),
        isSearch: false
    };
};

function programChannels(channels$$1) {
    return function () {
        var _ref2 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
            var _this = this;

            var _getState, options$$1, isSingleChannel, apiKey, childChannels, formattedChannels;

            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _getState = getState(), options$$1 = _getState.options;
                            isSingleChannel = channels$$1.length < 2;
                            apiKey = getApiKey(options$$1);
                            childChannels = [];
                            _context2.next = 6;
                            return Promise.all(channels$$1.map(function () {
                                var _ref3 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(rawTerm) {
                                    var term, _ref4, data, channel, children, _ref5, _data, _ref6, _data2;

                                    return regeneratorRuntime.wrap(function _callee$(_context) {
                                        while (1) {
                                            switch (_context.prev = _context.next) {
                                                case 0:
                                                    term = String(rawTerm);

                                                    if (!(term.indexOf('#') === 0)) {
                                                        _context.next = 9;
                                                        break;
                                                    }

                                                    _context.next = 4;
                                                    return fetchSearchGifs(term.replace('#', ''), 0, apiKey, 1);

                                                case 4:
                                                    _ref4 = _context.sent;
                                                    data = _ref4.data;
                                                    return _context.abrupt('return', getSearchTermData(term, data));

                                                case 9:
                                                    _context.next = 11;
                                                    return fetchChannelData(term, apiKey);

                                                case 11:
                                                    channel = _context.sent;

                                                    if (!channel) {
                                                        _context.next = 22;
                                                        break;
                                                    }

                                                    if (!isSingleChannel) {
                                                        _context.next = 19;
                                                        break;
                                                    }

                                                    _context.next = 16;
                                                    return fetchChannelChildren(channel.id, apiKey);

                                                case 16:
                                                    children = _context.sent;
                                                    _ref5 = children || {}, _data = _ref5.data;

                                                    _data && _data.forEach(function (child) {
                                                        var childData = getChannelData(child);
                                                        // override popout url with root channel
                                                        // until child channel urls are supported
                                                        childData.popoutUrl = popoutUrl(channel.slug);
                                                        childChannels.push(childData);
                                                    });

                                                case 19:
                                                    return _context.abrupt('return', getChannelData(channel));

                                                case 22:
                                                    _context.next = 24;
                                                    return fetchSearchGifs(term.replace('@', ''), 0, apiKey, 1);

                                                case 24:
                                                    _ref6 = _context.sent;
                                                    _data2 = _ref6.data;
                                                    return _context.abrupt('return', getSearchTermData(term, _data2));

                                                case 27:
                                                case 'end':
                                                    return _context.stop();
                                            }
                                        }
                                    }, _callee, _this);
                                }));

                                return function (_x4) {
                                    return _ref3.apply(this, arguments);
                                };
                            }()));

                        case 6:
                            formattedChannels = _context2.sent;

                            dispatch(setChannels([].concat(toConsumableArray(formattedChannels), childChannels)));
                            return _context2.abrupt('return', dispatch(changeChannel(0)));

                        case 9:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        return function (_x2, _x3) {
            return _ref2.apply(this, arguments);
        };
    }();
}

function programGifs(gifs$$1) {
    return function (dispatch, getState) {
        var _getState2 = getState(),
            options$$1 = _getState2.options;

        var apiKey = getApiKey(options$$1);
        var gifLimit = getGifLimit(options$$1);
        var gifIds = gifs$$1.map(function (gif) {
            return gifToId(gif);
        });
        return fetchGifsById(gifIds, apiKey).then(function (_ref7) {
            var data = _ref7.data,
                meta = _ref7.meta;

            dispatch(setGifs(data, 0, meta));
            dispatch(setGifsTotal(data.length));
            dispatch(setGifsCurrentIndex(0, gifLimit));
        });
    };
}

function changeChannel(index) {
    return function (dispatch, getState) {
        dispatch(resetGifs());
        dispatch(setCurrentChannel(index));

        var _getState3 = getState(),
            channels$$1 = _getState3.channels,
            options$$1 = _getState3.options;

        var _getCurrentChannel = getCurrentChannel(channels$$1),
            term = _getCurrentChannel.term;

        var isRandom = getIsRandom(options$$1);
        var storedIndex = isRandom ? 0 : getItem(term);
        return dispatch(changeGif(storedIndex || 0));
    };
}

function getMoreGifs(currentIndex, page) {
    return function (dispatch, getState) {
        var _getState4 = getState(),
            gifs$$1 = _getState4.gifs,
            channels$$1 = _getState4.channels,
            options$$1 = _getState4.options;

        var _getCurrentChannel2 = getCurrentChannel(channels$$1),
            term = _getCurrentChannel2.term,
            isSearch = _getCurrentChannel2.isSearch;

        var apiKey = getApiKey(options$$1);
        var gifLimit = getGifLimit(options$$1);
        var gifOffset = getGifOffset(options$$1);
        var isRandom = getIsRandom(options$$1);
        var total = getTotalGifs(gifs$$1);
        var fetch = isSearch ? fetchSearchGifs : fetchChannelGifs;
        dispatch(setGifsFetching(true));
        return fetch(term, page, apiKey, gifLimit, gifOffset).then(function (_ref8) {
            var data = _ref8.data,
                pagination = _ref8.pagination,
                meta = _ref8.meta;

            if (!data.length) {
                throw new Error('No more gifs');
            }

            // scramble gifs if random is on
            isRandom && randomize(data);

            dispatch(setGifs(data, page, meta));
            if (!total && pagination && pagination.total_count) {
                dispatch(setGifsTotal(pagination.total_count || 0));
            }
            dispatch(setGifsCurrentIndex(currentIndex, gifLimit));
        }).catch(function () {
            var cutoffTotal = getGifs(gifs$$1).length;
            var cutoffIndex = Math.max(0, cutoffTotal ? currentIndex % cutoffTotal : currentIndex);
            if (cutoffTotal > 0) {
                dispatch(setGifsTotal(cutoffTotal));
                dispatch(setGifsFullyLoaded(true));
                dispatch(changeGif(cutoffIndex));
            }
        });
    };
}

function changeGif(index) {
    return function (dispatch, getState) {
        var _getState5 = getState(),
            gifs$$1 = _getState5.gifs,
            channels$$1 = _getState5.channels,
            options$$1 = _getState5.options;

        var apiKey = getApiKey(options$$1);
        var gifLimit = getGifLimit(options$$1);
        var pages = getPages(gifs$$1);
        var total = getTotalGifs(gifs$$1);
        var isFullyLoaded = getIsFullyLoaded(gifs$$1);
        var currentIndex = total ? index % total : index;
        currentIndex = currentIndex < 0 && total ? total - 1 : Math.max(0, currentIndex);
        var page = Math.floor(currentIndex / gifLimit);

        var _getCurrentChannel3 = getCurrentChannel(channels$$1),
            term = _getCurrentChannel3.term;

        // no gifs exist yet for this index,
        // we need to fetch em...


        if (!pages[page]) {
            return dispatch(getMoreGifs(currentIndex, page));
        }

        // less than 25 gifs exist in this index,
        // so we need to account for that...
        if (pages[page].length < gifLimit) {
            var offsetIndex = currentIndex % gifLimit;
            if (offsetIndex >= pages[page].length) {
                dispatch(setGifsTotal(currentIndex));
                dispatch(setGifsFullyLoaded(true));
                setItem(term, 0);
                return dispatch(setGifsCurrentIndex(0, gifLimit));
            }
        }

        // more than half way through, so let's
        // load the next page
        if (!isFullyLoaded && currentIndex % gifLimit >= gifLimit / 2 && !pages[page + 1]) {
            dispatch(getMoreGifs(currentIndex, page + 1, apiKey));
        }

        setItem(term, currentIndex);
        return dispatch(setGifsCurrentIndex(currentIndex, gifLimit));
    };
}

function swipe(_ref9) {
    var _ref9$x = _ref9.x,
        x = _ref9$x === undefined ? 0 : _ref9$x,
        _ref9$y = _ref9.y,
        y = _ref9$y === undefined ? 0 : _ref9$y,
        _ref9$preview = _ref9.preview,
        preview = _ref9$preview === undefined ? '' : _ref9$preview,
        _ref9$previewLabel = _ref9.previewLabel,
        previewLabel = _ref9$previewLabel === undefined ? '' : _ref9$previewLabel,
        _ref9$isSwiped = _ref9.isSwiped,
        isSwiped = _ref9$isSwiped === undefined ? false : _ref9$isSwiped,
        _ref9$isReset = _ref9.isReset,
        isReset = _ref9$isReset === undefined ? false : _ref9$isReset;

    return function (dispatch) {
        if (isReset) {
            return dispatch(resetSwipe());
        }
        if (isSwiped) {
            return dispatch(setIsSwiped(x, y));
        }
        if (Math.abs(x)) {
            return dispatch(setSwipeHorizontal(x, preview, previewLabel));
        }
        if (Math.abs(y)) {
            return dispatch(setSwipeVertical(y, preview, previewLabel));
        }
        return dispatch(resetSwipe());
    };
}

var reportEvent = function reportEvent(action, data) {
    return function (dispatch, getState) {
        var _getState6 = getState(),
            gifs$$1 = _getState6.gifs;

        var _getCurrentGif = getCurrentGif(gifs$$1),
            id = _getCurrentGif.id;
        // ga


        if (isGAAction(action)) {
            var label = id;
            // use gif id as label for everything except
            if (action === ACTIONS.CHANGE_CHANNEL || action === ACTIONS.SHARE) {
                // then use the data passed in
                label = data;
            }
            Logger.info('ga event ', { action: action, label: label });
            gaEvent({ action: action, label: label });
        }
        // pingback

        var _getMeta = getMeta(gifs$$1),
            response_id = _getMeta.response_id;

        var p = createPingbackEvent({ action: action, data: data, response_id: response_id, gif_id: id });
        Logger.info('pingback event actions  ', p.actions[0]);
        return pingbackEvent(p);
    };
};

var actions = {
    reportEvent: reportEvent,
    swipe: swipe,
    changeGif: changeGif,
    getMoreGifs: getMoreGifs,
    changeChannel: changeChannel,
    programGifs: programGifs,
    programChannels: programChannels
};

if (typeof global$1.setTimeout === 'function') {
    
}
if (typeof global$1.clearTimeout === 'function') {
    
}







 // empty string to avoid regexp issues


















// from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js
var performance = global$1.performance || {};
var performanceNow =
  performance.now        ||
  performance.mozNow     ||
  performance.msNow      ||
  performance.oNow       ||
  performance.webkitNow  ||
  function(){ return (new Date()).getTime() };

// generate timestamp or delta
// see http://nodejs.org/api/process.html#process_process_hrtime

var SET_DIMENSIONS = 'SET_DIMENSIONS';

var DEFAULTS$4 = {
    width: 0,
    height: 0
};

var dimensions = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULTS$4;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case SET_DIMENSIONS:
            return _extends({}, state, { width: action.width, height: action.height });
        default:
            return state;
    }
});

var setDimensions = function setDimensions(_ref) {
    var _ref$width = _ref.width,
        width = _ref$width === undefined ? 0 : _ref$width,
        _ref$height = _ref.height,
        height = _ref$height === undefined ? 0 : _ref$height;
    return { type: SET_DIMENSIONS, width: width, height: height };
};

var getWidth = function getWidth(state) {
    return state.width;
};
var getHeight = function getHeight(state) {
    return state.height;
};

var SET_IS_OVERLAY_ON = 'SET_IS_OVERLAY_ON';
var SET_IS_MUTED = 'SET_IS_MUTED';
var SET_IS_PAUSED = 'SET_IS_PAUSED';
var SET_IS_SHARE = 'SET_IS_SHARE';
var SET_IS_CHANNEL_CHANGER = 'SET_IS_CHANNEL_CHANGER';
var SET_IS_SUBSECTION = 'SET_IS_SUBSECTION';
var SET_IS_FULLSCREEN = 'SET_IS_FULLSCREEN';
var SET_MESSAGE = 'SET_MESSAGE';

var DEFAULTS$5 = {
    message: '',
    isErrorMessage: false,
    isOn: false,
    isMuted: true,
    isPaused: false,
    isShare: false,
    isFullscreen: false,
    isChannelChanger: false,
    isSubsection: false
};

var overlay = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULTS$5;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case SET_IS_OVERLAY_ON:
            return _extends({}, state, { isOn: !!action.isOn, message: '', isErrorMessage: false });
        case SET_IS_MUTED:
            return _extends({}, state, { isMuted: action.isMuted });
        case SET_IS_PAUSED:
            return _extends({}, state, { isPaused: action.isPaused });
        case SET_IS_SHARE:
            return _extends({}, state, { isShare: action.isShare, isSubsection: action.isShare });
        case SET_IS_CHANNEL_CHANGER:
            return _extends({}, state, { isChannelChanger: action.isChanger, isSubsection: action.isChanger });
        case SET_IS_SUBSECTION:
            return _extends({}, state, { isSubsection: action.isSubsection, isShare: false, isChannelChanger: false });
        case SET_IS_FULLSCREEN:
            return _extends({}, state, { isFullscreen: action.isFullscreen });
        case SET_MESSAGE:
            return _extends({}, state, { message: action.message || '', isErrorMessage: action.isError || false });
        default:
            return state;
    }
});

var setIsOverlayOn = function setIsOverlayOn(isOn) {
    return { type: SET_IS_OVERLAY_ON, isOn: isOn };
};

var setIsPaused = function setIsPaused(isPaused) {
    return { type: SET_IS_PAUSED, isPaused: isPaused };
};
var setIsShare = function setIsShare(isShare) {
    return { type: SET_IS_SHARE, isShare: isShare };
};
var setIsChannelChanger = function setIsChannelChanger(isChanger) {
    return { type: SET_IS_CHANNEL_CHANGER, isChanger: isChanger };
};
var setIsSubsection = function setIsSubsection(isSubsection) {
    return { type: SET_IS_SUBSECTION, isSubsection: isSubsection };
};
var setIsFullscreen = function setIsFullscreen(isFullscreen) {
    return { type: SET_IS_FULLSCREEN, isFullscreen: isFullscreen };
};
var setMessage = function setMessage(message, isError) {
    return { type: SET_MESSAGE, message: message, isError: isError };
};

var getIsOverlayOn = function getIsOverlayOn(state) {
    return state.isOn;
};
var getIsMuted = function getIsMuted(state) {
    return state.isMuted;
};
var getIsPaused = function getIsPaused(state) {
    return state.isPaused || state.isOn && state.isSubsection;
}; // pause when subsection is open
var getIsShare = function getIsShare(state) {
    return state.isShare;
};
var getIsChannelChanger = function getIsChannelChanger(state) {
    return state.isChannelChanger;
};
var getIsSubsection = function getIsSubsection(state) {
    return state.isSubsection;
};
var getIsErrorMessage = function getIsErrorMessage(state) {
    return state.isErrorMessage;
};
var getIsFullscreen = function getIsFullscreen(state) {
    return state.isFullscreen;
};
var getMessage = function getMessage(state) {
    return state.message;
};

var LOG = 'production' !== 'production';
var middleware = LOG ? applyMiddleware(thunk, createLogger({ collapsed: true })) : applyMiddleware(thunk);
var finalCreateStore = compose(middleware)(createStore);

var store = finalCreateStore(combineReducers({ gifs: gifs, channels: channels, swiping: swiping, options: options, dimensions: dimensions, overlay: overlay }));

function getSocialUrls(gif, isMobile$$1) {
    /**
     * Utility function which will return
     * an array with social share objects including channel & url.
     *
     * @param {String} url - the main gif url
     * @return {Object} contains channel names as properties
     * with their corresponding share urls
     */
    var url = gif.url,
        bitly_url = gif.bitly_url,
        id = gif.id;

    var imageUrl = getUrl(gif);
    var tumblrImageUrl = getUrl(gif, 'downsized');

    if (!url) return;

    var twitterUrl = '';

    if (isMobile$$1) {
        twitterUrl = 'http://twitter.com/share?url=' + encodeURIComponent(bitly_url) + '?tc=1&via=giphy';
    } else {
        twitterUrl = 'https://giphy.com/login/twitter?next=https://giphy.com/login/twitter/finalize?next=';
        twitterUrl += 'https://giphy.com/gifs/' + id + '/tweet';
    }

    return {
        facebook: 'http://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url),
        twitter: twitterUrl,
        // instagram: '',
        tumblr: 'http://www.tumblr.com/widgets/share/tool?canonicalUrl=' + encodeURIComponent(url) + '&content=' + encodeURIComponent(tumblrImageUrl) + '&caption=(via <a href=\'' + bitly_url + '\'>GIPHY</a>)&clickthroughUrl=' + encodeURIComponent(bitly_url) + '&posttype=photo&tags=giphy',
        pinterest: 'http://www.pinterest.com/pin/create/link/?url=' + encodeURIComponent(url) + '&media=' + encodeURIComponent(imageUrl) + '&description=via GIPHY',
        reddit: 'http://www.reddit.com/submit?url=' + encodeURIComponent(url)
    };
}

function openPopup(url, type, width, height) {
    var left = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    var top = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

    if (!url) return;

    var options = '';
    var defaults = {
        height: height,
        left: left,
        location: 0,
        menubar: 0,
        resizable: 1,
        status: 0,
        toolbar: 0,
        top: top > 0 ? top + 25 : 0,
        width: width
    };

    for (var option in defaults) {
        options += option + '=' + defaults[option] + ',';
    }

    window.open(url, '_blank', options);
}

function favoriteGif(_ref) {
    var id = _ref.id,
        slug = _ref.slug;

    document.cookie = 'fave=' + id;
    window.open('https://giphy.com/login?next=/gifs/' + slug, '_blank');
}

var getScrollTop = function getScrollTop() {
    return window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
};
var getScrollLeft = function getScrollLeft() {
    return window.pageXOffset !== undefined ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft;
};

var UserProps = PropTypes.shape({
    attribution_display_name: PropTypes.string,
    avatar_url: PropTypes.string,
    banner_url: PropTypes.string,
    display_name: PropTypes.string,
    is_public: PropTypes.bool,
    name: PropTypes.string,
    profile_url: PropTypes.string,
    profile_path: PropTypes.string,
    suppress_chrome: PropTypes.bool,
    username: PropTypes.string,
    twitter: PropTypes.string,
    facebook_url: PropTypes.string,
    twitter_url: PropTypes.string,
    tumblr_url: PropTypes.string,
    instagram_url: PropTypes.string
});

var string$2 = PropTypes.string;
var number$2 = PropTypes.number;
var oneOfType$2 = PropTypes.oneOfType;


var imageProps = {
    height: oneOfType$2([number$2, string$2]),
    url: string$2,
    width: oneOfType$2([number$2, string$2])
};

var string$1 = PropTypes.string;
var number$1 = PropTypes.number;
var oneOfType$1 = PropTypes.oneOfType;
var shape$1 = PropTypes.shape;


var ImageProps = shape$1({
    downsized: shape$1(_extends({}, imageProps, {
        size: oneOfType$1([number$1, string$1])
    })),
    downsized_large: shape$1(_extends({}, imageProps, {
        size: oneOfType$1([number$1, string$1])
    })),
    downsized_still: shape$1(_extends({}, imageProps)),
    fixed_height: shape$1(_extends({}, imageProps, {
        mp4: string$1
    })),
    fixed_height_downsampled: shape$1(imageProps),
    fixed_height_small: shape$1(imageProps),
    fixed_height_small_still: shape$1(imageProps),
    fixed_height_still: shape$1(imageProps),
    fixed_width: shape$1(_extends({}, imageProps, {
        mp4: string$1
    })),
    fixed_width_downsampled: shape$1(imageProps),
    fixed_width_small: shape$1(imageProps),
    fixed_width_small_still: shape$1(imageProps),
    fixed_width_still: shape$1(imageProps),
    looping: shape$1({
        mp4: string$1
    }),
    mp4: shape$1(imageProps),
    source: shape$1(imageProps),
    original: shape$1(_extends({}, imageProps, {
        frames: oneOfType$1([number$1, string$1]),
        mp4: string$1,
        size: oneOfType$1([number$1, string$1])
    })),
    original_still: shape$1(imageProps)
});

var string = PropTypes.string;
var number = PropTypes.number;
var bool = PropTypes.bool;
var oneOfType = PropTypes.oneOfType;
var shape = PropTypes.shape;


var gifProps = shape({
    bitly_url: string,
    create_datetime: string,
    embed_url: string,
    id: oneOfType([string, number]),
    rating: string,
    slug: string,
    tags_string: string,
    type: string,
    url: string,
    username: string,
    update_datetime: string,

    source_caption: string,
    source_content_url: string,
    source_domain: string,
    source_image_url: string,
    source_post_url: string,
    source_tld: string,

    user: UserProps,
    images: ImageProps,

    is_anonymous: oneOfType([bool, number]),
    is_community: oneOfType([bool, number]),
    is_featured: oneOfType([bool, number]),
    is_hidden: oneOfType([bool, number]),
    is_preserve_size: bool,
    is_realtime: oneOfType([bool, number]),
    is_removed: oneOfType([bool, number]),
    is_sticker: oneOfType([bool, number])
});

var CHILL_ZONE = [];

var loadImage = function loadImage(image) {
    return new Promise(function (resolve, reject) {
        if (image && CHILL_ZONE[image]) {
            resolve();
        } else if (!image) {
            reject(new Error('No image provided'));
        } else {
            var img = document.createElement('img');
            // Ignore crossOrigin for base64 image strings.
            // This was causing an error in Safari.
            if (image.indexOf('data:image') !== 0) {
                img.crossOrigin = 'anonymous';
            }
            img.onload = function () {
                CHILL_ZONE.push(image);
                resolve();
            };
            img.onerror = function () {
                return reject(new Error('An error occurred while loading ' + image));
            };
            img.src = image;
        }
    });
};

function preloadImage(images) {
    if (isArray(images)) {
        return Promise.all(images.map(function (image) {
            return loadImage(image);
        }));
    }

    return loadImage(images);
}

var Video = (function (_ref) {
    var gif = _ref.gif,
        className = _ref.className,
        width = _ref.width,
        height = _ref.height,
        isMuted = _ref.isMuted,
        isLetterbox = _ref.isLetterbox,
        onUpdate = _ref.onUpdate,
        onReady = _ref.onReady,
        onError = _ref.onError;
    return React.createElement('video', {
        className: className,
        autoPlay: true,
        loop: true,
        playsInline: true,
        muted: isMuted,
        src: findBestVideo(gif, width, height),
        'data-letterbox': isLetterbox,
        onTimeUpdate: onUpdate,
        onCanPlay: onReady,
        onError: onError
    });
});

var css = __$styleInject("._fill_11q65_1 {\r\n    height: 100%;\r\n    left: 0;\r\n    pointer-events: none;\r\n    position: absolute;\r\n    top: 0;\r\n    width: 100%;\r\n}\r\n\r\n._container_11q65_19 {\r\n    overflow: hidden;\r\n}\r\n._stickerContainer_11q65_27 {\r\n    background-color: #121212;\r\n    background-image: linear-gradient(45deg, #222 25%, transparent 25%,transparent 75%, #222 75%, #222 100%),\r\n        linear-gradient(45deg, #222 25%, transparent 25%,transparent 75%, #222 75%, #222 100%);\r\n    background-position: 0 0, 19px 19px;\r\n    background-size: 38px 38px;\r\n}\r\n._video_11q65_43 {\r\n    background: transparent;\r\n    -o-object-fit: cover;\r\n       object-fit: cover;\r\n    -webkit-transition: opacity .2s ease-out;\r\n    transition: opacity .2s ease-out;\r\n}\r\n._video_11q65_43[data-letterbox=\"true\"] {\r\n        -o-object-fit: contain;\r\n           object-fit: contain;\r\n    }\r\n._videoHidden_11q65_63 {\r\n    opacity: 0;\r\n    -webkit-transition: none;\r\n    transition: none;\r\n}\r\n\r\n._preview_11q65_75 {\r\n    -o-object-fit: contain;\r\n       object-fit: contain;\r\n    -webkit-transition: opacity .2s ease-out;\r\n    transition: opacity .2s ease-out;\r\n}\r\n._previewFull_11q65_85 {\r\n    -o-object-fit: cover;\r\n       object-fit: cover;\r\n}\r\n._previewHidden_11q65_93 {\r\n    opacity: 0;\r\n    -webkit-transition: none;\r\n    transition: none;\r\n}\r\n\r\n._background_11q65_105 {\r\n    background-position: center center;\r\n    background-repeat: no-repeat;\r\n    background-size: contain;\r\n    pointer-events: none;\r\n}\r\n._backgroundFull_11q65_119 {\r\n    background-size: cover;\r\n}\r\n", { "fill": "_fill_11q65_1", "container": "_container_11q65_19 _fill_11q65_1", "stickerContainer": "_stickerContainer_11q65_27 _container_11q65_19 _fill_11q65_1", "video": "_video_11q65_43 _fill_11q65_1", "videoHidden": "_videoHidden_11q65_63 _video_11q65_43 _fill_11q65_1", "preview": "_preview_11q65_75 _fill_11q65_1", "previewFull": "_previewFull_11q65_85 _preview_11q65_75 _fill_11q65_1", "previewHidden": "_previewHidden_11q65_93 _preview_11q65_75 _fill_11q65_1", "background": "_background_11q65_105 _fill_11q65_1", "backgroundFull": "_backgroundFull_11q65_119 _background_11q65_105 _fill_11q65_1" });

var _dec$1;
var _class$2;
var _class2$1;
var _temp2$1;

var Gif = (_dec$1 = connect(function (_ref) {
    var gifs$$1 = _ref.gifs,
        swiping$$1 = _ref.swiping,
        options$$1 = _ref.options,
        dimensions$$1 = _ref.dimensions,
        overlay$$1 = _ref.overlay;
    return {
        gif: getCurrentGif(gifs$$1),
        nextGif: getNextGif(gifs$$1),
        previousGif: getPreviousGif(gifs$$1),
        width: getWidth(dimensions$$1),
        height: getHeight(dimensions$$1),
        delay: getGifDelay(options$$1),
        opacity: 1 - getSwipeProgress(swiping$$1),
        isSwiped: getIsSwiped(swiping$$1),
        isForceGifs: getIsForceGifs(options$$1),
        isLetterbox: getIsLetterbox(options$$1),
        isPaused: getIsPaused(overlay$$1),
        isMuted: getIsMuted(overlay$$1)
    };
}, { reportEvent: actions.reportEvent }), _dec$1(_class$2 = (_temp2$1 = _class2$1 = function (_PureComponent) {
    inherits(Gif, _PureComponent);

    function Gif() {
        var _ref2;

        var _temp, _this, _ret;

        classCallCheck(this, Gif);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref2 = Gif.__proto__ || Object.getPrototypeOf(Gif)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
            isReady: false,
            isGifFallback: false
        }, _this.viewDelay = null, _this.isTimeUp = false, _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(Gif, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.reportGif();
            this.reset();
            this.preloadNextPrevious();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var _props = this.props,
                gif = _props.gif,
                isPaused = _props.isPaused;

            // if the current gif changes, kill
            // the view timer and reset isReady

            if (prevProps.gif !== gif) {
                this.reportGif();
                this.reset();
                this.preloadNextPrevious();
            }

            // stop the view timer if paused, or start
            // if resuming video
            if (prevProps.isPaused !== isPaused) {
                clearTimeout(this.viewDelay);
                !isPaused && this.startTimer();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearTimeout(this.viewDelay);
        }
    }, {
        key: 'reportGif',
        value: function reportGif() {
            var reportEvent$$1 = this.props.reportEvent;

            reportEvent$$1(ACTIONS.GIF_SHOWN);
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.isTimeUp = false;
            clearTimeout(this.viewDelay);
            this.setState({ isReady: false, isGifFallback: this.props.gif.is_sticker || false });
            this.startTimer();
        }
    }, {
        key: 'preloadNextPrevious',
        value: function preloadNextPrevious() {
            var _props2 = this.props,
                nextGif = _props2.nextGif,
                previousGif = _props2.previousGif;

            var nextPreview = getPreview(nextGif);
            var previousPreview = getPreview(previousGif);

            nextPreview && preloadImage(nextPreview);
            previousPreview && preloadImage(previousPreview);
        }
    }, {
        key: 'startTimer',
        value: function startTimer() {
            var _this2 = this;

            var _props3 = this.props,
                delay = _props3.delay,
                isForceGifs = _props3.isForceGifs,
                onViewed = _props3.onViewed;

            this.viewDelay = setTimeout(function () {
                _this2.isTimeUp = true;
                if (isForceGifs || _this2.state.isGifFallback) {
                    onViewed();
                }
            }, delay);
        }
    }, {
        key: 'onVideoReady',
        value: function onVideoReady() {
            this.setState({ isReady: true });
        }
    }, {
        key: 'onVideoError',
        value: function onVideoError() {
            this.setState({ isGifFallback: true });
        }
    }, {
        key: 'onVideoUpdate',
        value: function onVideoUpdate(_ref3) {
            var target = _ref3.target;
            var _props4 = this.props,
                onViewed = _props4.onViewed,
                isPaused = _props4.isPaused;

            if (!isPaused && target.currentTime === 0 && this.isTimeUp) {
                this.isTimeUp = false;
                onViewed();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props5 = this.props,
                gif = _props5.gif,
                opacity = _props5.opacity,
                width = _props5.width,
                height = _props5.height,
                isMuted = _props5.isMuted,
                isSwiped = _props5.isSwiped,
                isForceGifs = _props5.isForceGifs;
            var _state = this.state,
                isGifFallback = _state.isGifFallback,
                isReady = _state.isReady;

            var isSticker = gif.is_sticker || false;
            var isLetterbox = isSticker || this.props.isLetterbox;
            var preview$$1 = getPreview(gif);
            return !gif ? null : React.createElement(
                'div',
                {
                    className: isSticker ? css.stickerContainer : css.container,
                    'data-swiped': isSwiped,
                    style: {
                        opacity: opacity
                    }
                },
                React.createElement('div', {
                    className: isLetterbox ? css.background : css.backgroundFull,
                    style: {
                        backgroundImage: 'url(' + preview$$1 + ')'
                    }
                }),
                !isForceGifs && !isGifFallback && !isSticker && React.createElement(Video, {
                    key: gif.id,
                    gif: gif,
                    className: isReady ? css.video : css.videoHidden,
                    height: height,
                    width: width,
                    imgClassName: isLetterbox ? css.preview : css.previewFull,
                    isMuted: isMuted,
                    isLetterbox: isLetterbox,
                    onUpdate: function onUpdate(e) {
                        return _this3.onVideoUpdate(e);
                    },
                    onReady: function onReady() {
                        return _this3.onVideoReady();
                    },
                    onError: function onError() {
                        return _this3.onVideoError();
                    }
                }),
                (isForceGifs || isGifFallback) && React.createElement('img', {
                    className: !isReady ? css.previewHidden : isLetterbox ? css.preview : css.previewFull,
                    src: getUrl(gif, 'original', true),
                    alt: '',
                    onLoad: function onLoad() {
                        return _this3.onVideoReady();
                    },
                    onError: function onError(e) {
                        return e.target.src = getUrl(gif, 'original');
                    }
                })
            );
        }
    }]);
    return Gif;
}(PureComponent), _class2$1.propTypes = {
    gif: gifProps.isRequired,
    nextGif: gifProps,
    previousGif: gifProps,
    width: PropTypes.number,
    height: PropTypes.number,
    opacity: PropTypes.number,
    delay: PropTypes.number,
    isLetterbox: PropTypes.bool,
    isForceGifs: PropTypes.bool,
    isSwiped: PropTypes.bool,
    isPaused: PropTypes.bool,
    isMuted: PropTypes.bool,
    onViewed: PropTypes.func.isRequired
}, _temp2$1)) || _class$2);

var Verified = (function (_ref) {
    var className = _ref.className;
    return React.createElement(
        "svg",
        { className: className, viewBox: "-1 0 18 18", version: "1.1", title: "Verified" },
        React.createElement(
            "g",
            { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement(
                "g",
                { transform: "translate(-324.000000, -132.000000)", fill: "#15CDFF" },
                React.createElement(
                    "g",
                    { id: "Group-3", transform: "translate(323.000000, 132.000000)" },
                    React.createElement("polygon", { points: "8.95093746 16.1755971 6.18494567 16.8455287 4.34519872 14.6949378 1.70947694 13.628319 1.49869564 10.8185214 2.85993451e-13 8.42276436 1.49869564 6.02700728 1.70947694 3.21720971 4.34519872 2.1505909 6.18494567 4.92383911e-14 8.95093746 0.669931593 11.7169293 4.82947016e-14 13.5566762 2.1505909 16.192398 3.21720971 16.4031793 6.02700728 17.9018749 8.42276436 16.4031793 10.8185214 16.192398 13.628319 13.5566762 14.6949378 11.7169293 16.8455287" }),
                    React.createElement("path", {
                        d: "M9.32727273,9.44126709 L9.32727273,3.03016561 L6.55027155,3.03016561 L6.55027155,10.8150746 L6.55027155,12.188882 L12.1042739,12.188882 L12.1042739,9.44126709 L9.32727273,9.44126709 Z",
                        fill: "#121212",
                        transform: "translate(9.327273, 7.609524) scale(-1, 1) rotate(-45.000000) translate(-9.327273, -7.609524) "
                    })
                )
            )
        )
    );
});

var css$1 = __$styleInject("._container_18wzl_1 {\r\n    height: 100%;\r\n    overflow: hidden;\r\n    -webkit-user-select: none;\r\n       -moz-user-select: none;\r\n        -ms-user-select: none;\r\n            user-select: none;\r\n    width: 100%;\r\n}\r\n\r\n._link_18wzl_15 {\r\n    -webkit-animation: _bloop_18wzl_1 .2s ease-out;\r\n            animation: _bloop_18wzl_1 .2s ease-out;\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    display: inline-block;\r\n    height: 100%;\r\n    padding: 16px;\r\n    max-width: 100%;\r\n    text-decoration: none;\r\n    -webkit-transform: translate3d(0, 0, 0);\r\n            transform: translate3d(0, 0, 0);\r\n}\r\n\r\n._avatar_18wzl_37 {\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n    background-size: cover;\r\n    float: left;\r\n    height: 36px;\r\n    margin-right: 10px;\r\n    width: 36px;\r\n}\r\n\r\n._info_18wzl_57 {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: column;\r\n            flex-direction: column;\r\n    height: 100%;\r\n}\r\n\r\n._username_18wzl_69 {\r\n    color: #ccc;\r\n    display: block;\r\n    font: \"Interface\", sans-serif;\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n    line-height: 18px;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n\r\n._displayName_18wzl_93 {\r\n    color: #fff;\r\n    font-size: 16px;\r\n    font-weight: 900;\r\n}\r\n\r\n._usernameWrapper_18wzl_107 {\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    height: 18px;\r\n}\r\n\r\n._verified_18wzl_119 {\r\n    height: 14px;\r\n    margin-left: 3px;\r\n    width: 14px;\r\n}\r\n\r\n@-webkit-keyframes _bloop_18wzl_1 {\r\n    0% {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(0, 15px, 0);\r\n                transform: translate3d(0, 15px, 0);\r\n    }\r\n    100% {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n                transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes _bloop_18wzl_1 {\r\n    0% {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(0, 15px, 0);\r\n                transform: translate3d(0, 15px, 0);\r\n    }\r\n    100% {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 0, 0);\r\n                transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n@media (max-width: 300px) {\r\n    ._avatar_18wzl_37 {\r\n        display: none;\r\n    }\r\n}\r\n", { "container": "_container_18wzl_1", "link": "_link_18wzl_15", "bloop": "_bloop_18wzl_1", "avatar": "_avatar_18wzl_37", "info": "_info_18wzl_57", "username": "_username_18wzl_69", "displayName": "_displayName_18wzl_93 _username_18wzl_69", "usernameWrapper": "_usernameWrapper_18wzl_107", "verified": "_verified_18wzl_119" });

var getSmallAvatar = function getSmallAvatar(_ref) {
    var avatar_url = _ref.avatar_url;

    if (!avatar_url) return '';

    var ext = avatar_url.split('.').pop().toLowerCase();
    return avatar_url.replace('media.giphy.com', 'imaging.giphy.com').replace('.' + ext, '/36h.' + ext);
};

var Attribution = function Attribution(_ref2) {
    var gif = _ref2.gif;

    var user = gif ? gif.user : null;
    return !user ? null : React.createElement(
        'div',
        { className: css$1.container },
        React.createElement(
            'a',
            { className: css$1.link, href: user.profile_url, target: '_blank' },
            user.avatar_url && React.createElement('div', { className: css$1.avatar, style: { backgroundImage: 'url(' + getSmallAvatar(user) + ')' } }),
            React.createElement(
                'div',
                { className: css$1.info },
                React.createElement(
                    'div',
                    { className: css$1.displayName },
                    user.display_name || user.username
                ),
                React.createElement(
                    'div',
                    { className: css$1.usernameWrapper },
                    React.createElement(
                        'span',
                        { className: css$1.username },
                        '@',
                        user.username
                    ),
                    user.is_verified ? React.createElement(Verified, { className: css$1.verified }) : null
                )
            )
        )
    );
};

var Attribution$1 = connect(function (_ref3) {
    var gifs$$1 = _ref3.gifs;
    return {
        gif: getCurrentGif(gifs$$1)
    };
})(Attribution);

var PlayIcon = (function (_ref) {
    var className = _ref.className,
        isFat = _ref.isFat,
        onClick = _ref.onClick;
    return React.createElement(
        "div",
        { className: className, "data-fatfingers": isFat, onClick: onClick },
        React.createElement(
            "svg",
            { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 19 23", width: "19", height: "23", style: { marginLeft: 4 } },
            React.createElement("path", {
                fill: "#FFF",
                fillRule: "evenodd",
                d: "M18.293 11.928L.76 22.54c-.237.144-.545.068-.688-.168-.047-.078-.072-.168-.072-.26V.888c0-.276.224-.5.5-.5.09 0 .18.025.26.072l17.532 10.61c.237.143.312.45.17.687-.043.068-.1.126-.17.168z"
            })
        )
    );
});

var PauseIcon = (function (_ref) {
    var className = _ref.className,
        isFat = _ref.isFat,
        onClick = _ref.onClick;
    return React.createElement(
        "div",
        { className: className, "data-fatfingers": isFat, onClick: onClick },
        React.createElement(
            "svg",
            { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 14 20", width: "14", height: "20" },
            React.createElement("path", {
                fill: "#FFF",
                fillRule: "evenodd",
                d: "M0 19V1c0-.552.448-1 1-1h3c.552 0 1 .448 1 1v18c0 .552-.448 1-1 1H1c-.552 0-1-.448-1-1zm9 0V1c0-.552.448-1 1-1h3c.552 0 1 .448 1 1v18c0 .552-.448 1-1 1h-3c-.552 0-1-.448-1-1z"
            })
        )
    );
});

var PreviousIcon = (function (_ref) {
    var className = _ref.className,
        isFat = _ref.isFat,
        onClick = _ref.onClick;
    return React.createElement(
        "div",
        { className: className, "data-fatfingers": isFat, onClick: onClick },
        React.createElement(
            "svg",
            { viewBox: "0 0 11 17", xmlns: "http://www.w3.org/2000/svg", height: "17", width: "11" },
            React.createElement("path", {
                d: "M.597 8.748l-.219.218L8.412 17l1.882-1.882-6.37-6.37 6.37-6.37L8.412.496.378 8.529l.219.219z",
                fill: "#FFF",
                fillRule: "evenodd"
            })
        )
    );
});

var NextIcon = (function (_ref) {
    var className = _ref.className,
        isFat = _ref.isFat,
        onClick = _ref.onClick;
    return React.createElement(
        "div",
        { className: className, "data-fatfingers": isFat, onClick: onClick },
        React.createElement(
            "svg",
            { viewBox: "0 0 11 17", xmlns: "http://www.w3.org/2000/svg", height: "17", width: "11" },
            React.createElement("path", {
                d: "M10.007 8.252l.278-.277L2.25-.06l-2 2 6.311 6.311-6.31 6.311 2 2 8.033-8.034-.278-.277z",
                fill: "#FFF",
                fillRule: "evenodd"
            })
        )
    );
});

var css$2 = __$styleInject("._container_7bjct_7 {\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    font-family: \"interface\", sans-serif;\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n    height: 100%;\r\n    left: 0;\r\n    padding: 0;\r\n    position: absolute;\r\n    top: 0;\r\n    width: 100%;\r\n    z-index: 10;\r\n}._container_7bjct_7 div[data-fatfingers=\"true\"] {\r\n        height: 50px;\r\n        opacity: 1;\r\n        width: 50px;\r\n    }._containerHidden_7bjct_45 {\r\n    pointer-events: none;\r\n}._wrapper_7bjct_55 {\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    height: 100%;\r\n    padding: 68px 0;\r\n    position: relative;\r\n    width: 100%;\r\n}._wrapperHidden_7bjct_69 ._header_7bjct_75 {\r\n        -webkit-transform: translate3d(0, -100px, 0);\r\n                transform: translate3d(0, -100px, 0);\r\n    }._wrapperHidden_7bjct_69 ._footer_7bjct_83 {\r\n        -webkit-transform: translate3d(0, 100px, 0);\r\n                transform: translate3d(0, 100px, 0);\r\n    }._wrapperHidden_7bjct_69 ._subsection_7bjct_91 {\r\n        opacity: 0;\r\n        pointer-events: none;\r\n    }._wrapperHidden_7bjct_69 ._gifLink_7bjct_101 {\r\n        display: none;\r\n    }._gifLink_7bjct_101 {\r\n    display: block;\r\n    height: 100%;\r\n    width: 100%;\r\n}._header_7bjct_75 {\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    height: 50px;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    left: 0;\r\n    position: absolute;\r\n    top: 0;\r\n    -webkit-transition: -webkit-transform .25s ease-out;\r\n    transition: -webkit-transform .25s ease-out;\r\n    transition: transform .25s ease-out;\r\n    transition: transform .25s ease-out, -webkit-transform .25s ease-out;\r\n    width: 100%;\r\n    z-index: 2;\r\n}._header_7bjct_75:before {\r\n        background: -webkit-gradient(linear,  left top, left bottom,  from(rgba(0, 0, 0, 0.5)), to(rgba(0, 0, 0, 0)));\r\n        background: linear-gradient(to bottom,  rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%);\r\n        content: \"\";\r\n        left: 0;\r\n        height: 90px;\r\n        pointer-events: none;\r\n        position: absolute;\r\n        top: -1px;\r\n        width: 100%;\r\n        z-index: -1;\r\n    }._headerPadded_7bjct_171 {\r\n    padding-right: 50px;\r\n}._footer_7bjct_83 {\r\n    bottom: 0;\r\n    height: 68px;\r\n    top: auto;\r\n}._footer_7bjct_83:before {\r\n        background: -webkit-gradient(linear,  left top, left bottom,  from(rgba(0, 0, 0, 0)), to(rgba(0, 0, 0, 0.5)));\r\n        background: linear-gradient(to bottom,  rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);\r\n        bottom: -1px;\r\n        top: auto;\r\n    }._subsection_7bjct_91 {\r\n    -webkit-animation: _subIn_7bjct_1 .25s ease-out;\r\n            animation: _subIn_7bjct_1 .25s ease-out;\r\n    background: rgba(0, 0, 0, 0.85);\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    height: 100%;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    left: 0;\r\n    position: absolute;\r\n    top: 0;\r\n    -webkit-transition: opacity .25s ease-out;\r\n    transition: opacity .25s ease-out;\r\n    width: 100%;\r\n}._button_7bjct_233 {\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    cursor: pointer;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-flex: 0;\r\n        -ms-flex-positive: 0;\r\n            flex-grow: 0;\r\n    -ms-flex-negative: 0;\r\n        flex-shrink: 0;\r\n    height: 36px;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    opacity: 0.88;\r\n    width: 36px;\r\n}._button_7bjct_233:hover {\r\n        opacity: 1;\r\n    }._button_7bjct_233:active {\r\n        opacity: 0.78;\r\n    }@-webkit-keyframes _subIn_7bjct_1 {\r\n    0% { opacity: 0; }\r\n    100% { opacity: 1; }\r\n}@keyframes _subIn_7bjct_1 {\r\n    0% { opacity: 0; }\r\n    100% { opacity: 1; }\r\n}\r\n\r\n._container_nz0c4_1 {\r\n    -webkit-box-flex: 0;\r\n        -ms-flex-positive: 0;\r\n            flex-grow: 0;\r\n    -ms-flex-negative: 0;\r\n        flex-shrink: 0;\r\n    height: 100%;\r\n    margin-left: auto;\r\n}\r\n\r\n._buttons_nz0c4_15 {\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    height: 100%;\r\n    -webkit-box-pack: justify;\r\n        -ms-flex-pack: justify;\r\n            justify-content: space-between;\r\n    padding: 0 14px;\r\n}\r\n._buttonsMobile_nz0c4_31 {\r\n    padding: 0 4px;\r\n}\r\n\r\n._button_nz0c4_15 {\r\n}", { "container": "_container_nz0c4_1", "buttons": "_buttons_nz0c4_15", "buttonsMobile": "_buttonsMobile_nz0c4_31 _buttons_nz0c4_15", "button": "_button_nz0c4_15 _button_7bjct_233" });

var IS_MOBILE = isMobile();
var Controls = function Controls(_ref) {
    var currentIndex = _ref.currentIndex,
        setIsPaused$$1 = _ref.setIsPaused,
        changeGif$$1 = _ref.changeGif,
        isPaused = _ref.isPaused,
        reportEvent$$1 = _ref.reportEvent;
    return React.createElement(
        'div',
        { className: css$2.container },
        React.createElement(
            'div',
            { className: IS_MOBILE ? css$2.buttonsMobile : css$2.buttons },
            React.createElement(PreviousIcon, {
                className: css$2.button,
                isFat: IS_MOBILE,
                onClick: function onClick() {
                    reportEvent$$1('Previous');
                    changeGif$$1(currentIndex - 1);
                }
            }),
            isPaused ? React.createElement(PlayIcon, {
                className: css$2.button,
                isFat: IS_MOBILE,
                onClick: function onClick() {
                    reportEvent$$1('Play');
                    setIsPaused$$1(false);
                }
            }) : React.createElement(PauseIcon, {
                className: css$2.button,
                isFat: IS_MOBILE,
                onClick: function onClick() {
                    reportEvent$$1('Pause');
                    setIsPaused$$1(true);
                }
            }),
            React.createElement(NextIcon, {
                className: css$2.button,
                isFat: IS_MOBILE,
                onClick: function onClick() {
                    reportEvent$$1('Next');
                    changeGif$$1(currentIndex + 1);
                }
            })
        )
    );
};

var Controls$1 = connect(function (_ref2) {
    var gifs$$1 = _ref2.gifs,
        overlay$$1 = _ref2.overlay;
    return {
        currentIndex: getCurrentIndex(gifs$$1),
        isPaused: getIsPaused(overlay$$1)
    };
}, {
    changeGif: actions.changeGif,
    setIsPaused: setIsPaused,
    reportEvent: actions.reportEvent
})(Controls);

var css$3 = __$styleInject("._container_7bjct_7 {\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    font-family: \"interface\", sans-serif;\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n    height: 100%;\r\n    left: 0;\r\n    padding: 0;\r\n    position: absolute;\r\n    top: 0;\r\n    width: 100%;\r\n    z-index: 10;\r\n}._container_7bjct_7 div[data-fatfingers=\"true\"] {\r\n        height: 50px;\r\n        opacity: 1;\r\n        width: 50px;\r\n    }._containerHidden_7bjct_45 {\r\n    pointer-events: none;\r\n}._wrapper_7bjct_55 {\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    height: 100%;\r\n    padding: 68px 0;\r\n    position: relative;\r\n    width: 100%;\r\n}._wrapperHidden_7bjct_69 ._header_7bjct_75 {\r\n        -webkit-transform: translate3d(0, -100px, 0);\r\n                transform: translate3d(0, -100px, 0);\r\n    }._wrapperHidden_7bjct_69 ._footer_7bjct_83 {\r\n        -webkit-transform: translate3d(0, 100px, 0);\r\n                transform: translate3d(0, 100px, 0);\r\n    }._wrapperHidden_7bjct_69 ._subsection_7bjct_91 {\r\n        opacity: 0;\r\n        pointer-events: none;\r\n    }._wrapperHidden_7bjct_69 ._gifLink_7bjct_101 {\r\n        display: none;\r\n    }._gifLink_7bjct_101 {\r\n    display: block;\r\n    height: 100%;\r\n    width: 100%;\r\n}._header_7bjct_75 {\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    height: 50px;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    left: 0;\r\n    position: absolute;\r\n    top: 0;\r\n    -webkit-transition: -webkit-transform .25s ease-out;\r\n    transition: -webkit-transform .25s ease-out;\r\n    transition: transform .25s ease-out;\r\n    transition: transform .25s ease-out, -webkit-transform .25s ease-out;\r\n    width: 100%;\r\n    z-index: 2;\r\n}._header_7bjct_75:before {\r\n        background: -webkit-gradient(linear,  left top, left bottom,  from(rgba(0, 0, 0, 0.5)), to(rgba(0, 0, 0, 0)));\r\n        background: linear-gradient(to bottom,  rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%);\r\n        content: \"\";\r\n        left: 0;\r\n        height: 90px;\r\n        pointer-events: none;\r\n        position: absolute;\r\n        top: -1px;\r\n        width: 100%;\r\n        z-index: -1;\r\n    }._headerPadded_7bjct_171 {\r\n    padding-right: 50px;\r\n}._footer_7bjct_83 {\r\n    bottom: 0;\r\n    height: 68px;\r\n    top: auto;\r\n}._footer_7bjct_83:before {\r\n        background: -webkit-gradient(linear,  left top, left bottom,  from(rgba(0, 0, 0, 0)), to(rgba(0, 0, 0, 0.5)));\r\n        background: linear-gradient(to bottom,  rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);\r\n        bottom: -1px;\r\n        top: auto;\r\n    }._subsection_7bjct_91 {\r\n    -webkit-animation: _subIn_7bjct_1 .25s ease-out;\r\n            animation: _subIn_7bjct_1 .25s ease-out;\r\n    background: rgba(0, 0, 0, 0.85);\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    height: 100%;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    left: 0;\r\n    position: absolute;\r\n    top: 0;\r\n    -webkit-transition: opacity .25s ease-out;\r\n    transition: opacity .25s ease-out;\r\n    width: 100%;\r\n}._button_7bjct_233 {\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    cursor: pointer;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-flex: 0;\r\n        -ms-flex-positive: 0;\r\n            flex-grow: 0;\r\n    -ms-flex-negative: 0;\r\n        flex-shrink: 0;\r\n    height: 36px;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    opacity: 0.88;\r\n    width: 36px;\r\n}._button_7bjct_233:hover {\r\n        opacity: 1;\r\n    }._button_7bjct_233:active {\r\n        opacity: 0.78;\r\n    }@-webkit-keyframes _subIn_7bjct_1 {\r\n    0% { opacity: 0; }\r\n    100% { opacity: 1; }\r\n}@keyframes _subIn_7bjct_1 {\r\n    0% { opacity: 0; }\r\n    100% { opacity: 1; }\r\n}\r\n\r\n._button_1msrq_1 {\r\n    margin: 0 2px;\r\n}\r\n\r\n._shareButton_1msrq_11 {\r\n    margin-left: auto;\r\n}\r\n\r\n._container_1msrq_21 {\r\n    -ms-flex-item-align: center;\r\n        align-self: center;\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    padding: 16px;\r\n    text-align: left;\r\n}\r\n\r\n._title_1msrq_35 {\r\n    display: block;\r\n    font-family: \"nexablack\", sans-serif;\r\n    font-size: 24px;\r\n    font-weight: normal;\r\n    line-height: 24px;\r\n    margin: 0 0 8px;\r\n    padding: 0;\r\n    text-transform: none;\r\n}\r\n\r\n._subtitle_1msrq_57 {\r\n    display: block;\r\n    font-size: 16px;\r\n    font-weight: normal;\r\n    line-height: 16px;\r\n    margin: 0 0 25px;\r\n    padding: 0;\r\n    text-transform: none;\r\n}\r\n\r\n._buttons_1msrq_77 {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    margin-bottom: 30px;\r\n    width: 100%;\r\n}\r\n\r\n._facebook_1msrq_89 {\r\n    background: #0093ff;\r\n}\r\n\r\n._twitter_1msrq_99 {\r\n    background: #00ceff;\r\n}\r\n\r\n._pinterest_1msrq_109 {\r\n    background: #e34bb3;\r\n}\r\n\r\n._tumblr_1msrq_119 {\r\n    background: #2c4762;\r\n}\r\n\r\n._reddit_1msrq_129 {\r\n    background: #fc6669;\r\n}\r\n\r\n._link_1msrq_139 {\r\n    background: #000;\r\n    margin-left: 15px;\r\n}\r\n\r\n._embed_1msrq_151 {\r\n    background: #000;\r\n}\r\n\r\n._favorite_1msrq_161 {\r\n    background: #000;\r\n}", { "button": "_button_1msrq_1 _button_7bjct_233", "shareButton": "_shareButton_1msrq_11 _button_7bjct_233", "container": "_container_1msrq_21", "title": "_title_1msrq_35", "subtitle": "_subtitle_1msrq_57", "buttons": "_buttons_1msrq_77", "facebook": "_facebook_1msrq_89 _button_1msrq_1 _button_7bjct_233", "twitter": "_twitter_1msrq_99 _button_1msrq_1 _button_7bjct_233", "pinterest": "_pinterest_1msrq_109 _button_1msrq_1 _button_7bjct_233", "tumblr": "_tumblr_1msrq_119 _button_1msrq_1 _button_7bjct_233", "reddit": "_reddit_1msrq_129 _button_1msrq_1 _button_7bjct_233", "link": "_link_1msrq_139 _button_1msrq_1 _button_7bjct_233", "embed": "_embed_1msrq_151 _button_1msrq_1 _button_7bjct_233", "favorite": "_favorite_1msrq_161 _button_1msrq_1 _button_7bjct_233" });

var ShareButton = function ShareButton(_ref) {
    var setIsShare$$1 = _ref.setIsShare;
    return React.createElement(
        'div',
        { className: css$3.shareButton, 'data-fatfingers': true, onClick: function onClick() {
                return setIsShare$$1(true);
            } },
        React.createElement(
            'svg',
            { viewBox: '0 0 18 18', xmlns: 'http://www.w3.org/2000/svg', height: '18', width: '18' },
            React.createElement('path', {
                d: 'M17.925.418l-2.24 17.244a.354.354 0 0 1-.21.29.31.31 0 0 1-.333 0l-5.698-2.847-2.057 2.741c-.07.1-.166.15-.289.15a.372.372 0 0 1-.131-.018c-.163-.053-.245-.173-.245-.36v-3.742c0-.1.026-.176.079-.229l8.157-10.541-10.6 9.188a.435.435 0 0 1-.253.08.306.306 0 0 1-.166-.044L.21 10.458c-.14-.064-.21-.17-.21-.316s.061-.263.184-.351L17.364.049a.367.367 0 0 1 .395.017c.128.094.184.211.166.352z',
                fill: '#FFF',
                fillRule: 'evenodd'
            })
        )
    );
};

var ShareIcon = connect(null, { setIsShare: setIsShare })(ShareButton);

var fitToSize = function fitToSize(width, height, fitWidth, fitHeight) {
    var scale = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'contain';

    var noScale = !scale || scale === 'none';
    var ratio = width / height;
    var maxWidth = noScale ? Math.min(width, fitWidth) : fitWidth;
    var maxHeight = noScale ? Math.min(height, fitHeight) : fitHeight;
    var newWidth = maxWidth;
    var newHeight = newWidth / ratio;
    if (scale === 'cover' && newHeight < maxHeight || scale !== 'cover' && newHeight > maxHeight) {
        newHeight = maxHeight;
        newWidth = newHeight * ratio;
    }
    return {
        width: newWidth,
        height: newHeight,
        left: (fitWidth - newWidth) / 2,
        top: (fitHeight - newHeight) / 2
    };
};

var fitGifToSize = function fitGifToSize(gif, fitWidth, fitHeight, scale) {
    var _getData = getData(gif),
        width = _getData.width,
        height = _getData.height;

    return fitToSize(width, height, fitWidth, fitHeight, scale);
};

var EMBED_SIZE = 480;

var getEmbedUrl = function getEmbedUrl(_ref) {
    var embed_url = _ref.embed_url;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var url$$1 = removeProtocol(embed_url);
    var params = omitBy(options, function (option) {
        return isBoolean(option) ? !option : option;
    });
    return isEmpty(params) ? url$$1 : appendQuery(url$$1, params);
};

var getEmbedCode = function getEmbedCode(gif) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var isResponsive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var url$$1 = gif.url;

    var _fitGifToSize = fitGifToSize(gif, EMBED_SIZE, EMBED_SIZE),
        width = _fitGifToSize.width,
        height = _fitGifToSize.height;

    var ratio = height / width;
    var params = {
        src: 'https:' + getEmbedUrl(gif, options),
        width: isResponsive ? '100%' : Math.round(width),
        height: isResponsive ? '100%' : Math.round(height),
        style: isResponsive ? 'position:absolute' : '',
        frameBorder: '0',
        class: 'giphy-embed'
    };

    var code = isResponsive ? '<div style="width:100%;height:0;padding-bottom:' + Math.round(ratio * 100) + '%;position:relative;">' : '';
    code += '<iframe';
    for (var param in params) {
        var value = params[param];
        code += value ? ' ' + param + '="' + value + '"' : '';
    }
    code += ' allowFullScreen></iframe>';
    code += isResponsive ? '</div>' : '';
    code += '<p><a href="' + url$$1 + '">via GIPHY</a></p>';

    return code;
};

var LinkIcon = (function () {
    return React.createElement(
        "svg",
        { width: "17", height: "17" },
        React.createElement(
            "defs",
            null,
            React.createElement("path", {
                d: "M19.734 12.414l-2.257 2.258a5.556 5.556 0 0 0-.329-2.477l1.18-1.203c.453-.458.68-1.009.68-1.652a2.24 2.24 0 0 0-.68-1.645 2.24 2.24 0 0 0-1.644-.68c-.644 0-1.194.227-1.653.68l-2.5 2.477a2.292 2.292 0 0 0-.68 1.66c0 .643.227 1.197.68 1.66a.918.918 0 0 1 .313.7.937.937 0 0 1-.313.706.94.94 0 0 1-.699.297.965.965 0 0 1-.707-.297 4.273 4.273 0 0 1-1.121-1.953 4.333 4.333 0 0 1 0-2.234 4.222 4.222 0 0 1 1.121-1.945l2.484-2.477a4.242 4.242 0 0 1 1.954-1.14 4.264 4.264 0 0 1 2.23 0c.742.197 1.39.578 1.941 1.14.563.552.943 1.2 1.141 1.941a4.264 4.264 0 0 1 0 2.23 4.242 4.242 0 0 1-1.14 1.954zm-4.828 4.836l-2.5 2.5a4.25 4.25 0 0 1-1.945 1.125 4.278 4.278 0 0 1-2.234 0 4.303 4.303 0 0 1-1.954-1.125 4.303 4.303 0 0 1-1.125-1.953 4.278 4.278 0 0 1 0-2.234 4.252 4.252 0 0 1 1.125-1.946l2.282-2.273a5.649 5.649 0 0 0 .328 2.5l-1.18 1.18a2.266 2.266 0 0 0-.68 1.652c0 .643.227 1.191.68 1.644a2.24 2.24 0 0 0 1.645.68c.643 0 1.194-.227 1.652-.68l2.477-2.476a2.22 2.22 0 0 0 .695-1.649 2.22 2.22 0 0 0-.695-1.648.966.966 0 0 1-.29-.711c0-.281.097-.52.29-.719a.953.953 0 0 1 .71-.297c.282 0 .521.1.72.297a4.273 4.273 0 0 1 1.12 1.953c.196.745.196 1.49 0 2.235a4.222 4.222 0 0 1-1.12 1.945z",
                id: "giphylinkicon"
            })
        ),
        React.createElement("use", { fill: "#FFF", xlinkHref: "#giphylinkicon", transform: "translate(-5 -5)", fillRule: "evenodd" })
    );
});

var FavIcon = (function () {
    return React.createElement(
        "svg",
        { width: "16", height: "14" },
        React.createElement(
            "defs",
            null,
            React.createElement("path", {
                d: "M18.783 14.36l-5.539 5.554a.432.432 0 0 1-.242.094.328.328 0 0 1-.242-.094L7.22 14.36c-.645-.645-1.154-1.306-1.527-1.98-.372-.675-.593-1.315-.664-1.922a3.943 3.943 0 0 1 .168-1.727 3.644 3.644 0 0 1 .914-1.449 4.222 4.222 0 0 1 1.942-1.12 4.304 4.304 0 0 1 2.226 0c.743.194 1.39.568 1.942 1.12.307.308.567.654.781 1.04.214-.386.474-.732.781-1.04a4.222 4.222 0 0 1 1.942-1.133 4.264 4.264 0 0 1 2.23 0 4.272 4.272 0 0 1 1.953 1.133 3.67 3.67 0 0 1 1.055 1.985c.135.755.02 1.578-.344 2.468-.364.891-.976 1.766-1.836 2.625z",
                id: "giphyfavoriteicon"
            })
        ),
        React.createElement("use", { fill: "#FFF", xlinkHref: "#giphyfavoriteicon", transform: "translate(-5 -6)", fillRule: "evenodd" })
    );
});

var EmbedIcon = (function () {
    return React.createElement(
        "svg",
        { width: "21", height: "12" },
        React.createElement(
            "defs",
            null,
            React.createElement("path", {
                d: "M18.002 7a.28.28 0 0 1 .176.07l5.754 5.748a.26.26 0 0 1 .07.182c0 .07-.023.13-.07.182l-5.754 5.748a.233.233 0 0 1-.179.076.233.233 0 0 1-.179-.076l-1.752-1.752a.242.242 0 0 1-.07-.179c0-.072.023-.132.07-.179l3.82-3.82-3.82-3.82a.242.242 0 0 1-.07-.179c0-.072.023-.132.07-.179L17.82 7.07a.288.288 0 0 1 .182-.07zM8.998 19a.281.281 0 0 1-.176-.07l-5.754-5.748a.259.259 0 0 1-.07-.182c0-.07.023-.13.07-.182L8.822 7.07a.233.233 0 0 1 .179-.076c.072 0 .132.026.179.076l1.752 1.752c.047.047.07.107.07.179a.242.242 0 0 1-.07.179L7.1 13l3.832 3.82c.047.047.07.107.07.179a.242.242 0 0 1-.07.179L9.18 18.93a.288.288 0 0 1-.182.07z",
                id: "giphyembedicon"
            })
        ),
        React.createElement("use", { fill: "#FFF", xlinkHref: "#giphyembedicon", transform: "translate(-3 -7)", fillRule: "evenodd" })
    );
});

var FBIcon = (function () {
    return React.createElement(
        "svg",
        { width: "18", height: "18" },
        React.createElement("path", {
            d: "M16.875 0c.305 0 .568.111.791.334.223.223.334.486.334.791v15.75c0 .305-.111.568-.334.791a1.081 1.081 0 0 1-.791.334h-4.5v-6.996h2.25l.378-2.593h-2.628V6.372c0-.375.095-.662.286-.861.19-.2.47-.3.839-.3h1.688V2.875a11.727 11.727 0 0 0-1.846-.123c-1.207 0-2.129.306-2.764.918-.636.613-.954 1.446-.954 2.5v2.242h-2.25v2.593h2.25V18H1.125a1.08 1.08 0 0 1-.791-.334A1.081 1.081 0 0 1 0 16.875V1.125C0 .82.111.557.334.334A1.08 1.08 0 0 1 1.125 0h15.75z",
            fill: "#FFF",
            fillRule: "evenodd"
        })
    );
});

var TwitterIcon = (function () {
    return React.createElement(
        "svg",
        { width: "18", height: "16" },
        React.createElement("path", {
            d: "M18 2.226a7.413 7.413 0 0 1-1.837 1.916v.483c0 .82-.104 1.645-.312 2.474-.208.83-.507 1.635-.896 2.417a9.871 9.871 0 0 1-1.499 2.193c-.61.68-1.292 1.273-2.048 1.78-.756.507-1.627.907-2.615 1.2-.987.292-2.028.439-3.124.439-2.22 0-4.11-.501-5.669-1.503a6.39 6.39 0 0 0 3.287-.413 8.521 8.521 0 0 0 2.171-1.274 3.492 3.492 0 0 1-2.14-.734A3.591 3.591 0 0 1 2.02 9.37c.247.047.475.07.686.07.34 0 .668-.044.984-.131a3.6 3.6 0 0 1-2.118-1.27A3.57 3.57 0 0 1 .73 5.688v-.043a3.68 3.68 0 0 0 1.67.457c-.51-.34-.912-.78-1.208-1.319a3.56 3.56 0 0 1-.444-1.74c0-.604.167-1.201.501-1.793a10.265 10.265 0 0 0 3.357 2.676c1.313.66 2.728 1.03 4.246 1.112a3.87 3.87 0 0 1-.08-.852c0-1.02.36-1.889 1.077-2.606A3.55 3.55 0 0 1 12.455.503c1.049 0 1.954.387 2.716 1.16A7.343 7.343 0 0 0 17.5.767a3.542 3.542 0 0 1-1.626 2.047A7.02 7.02 0 0 0 18 2.226z",
            fill: "#FFF",
            fillRule: "evenodd"
        })
    );
});

var PinterestIcon = (function () {
    return React.createElement(
        "svg",
        { width: "14", height: "16" },
        React.createElement("path", {
            d: "M7.367 0c.854 0 1.65.146 2.387.438.737.291 1.353.68 1.848 1.167a5.419 5.419 0 0 1 1.164 1.684c.28.635.421 1.292.421 1.969 0 1.193-.205 2.267-.617 3.222-.411.956-.994 1.707-1.75 2.254-.755.547-1.614.82-2.578.82a2.95 2.95 0 0 1-1.37-.327c-.425-.22-.721-.485-.888-.797-.349 1.406-.565 2.244-.648 2.515a6.15 6.15 0 0 1-.59 1.399c-.279.5-.501.864-.668 1.094a8.74 8.74 0 0 1-.39.507c-.042.047-.088.064-.137.051-.05-.013-.08-.043-.09-.09l-.027-.219a10.604 10.604 0 0 1-.09-1.043c-.01-.247-.015-.485-.012-.714a9.24 9.24 0 0 1 .043-.758c.026-.276.068-.531.125-.766l1.164-5c-.182-.396-.273-.883-.273-1.46 0-.683.169-1.25.507-1.7.339-.45.756-.676 1.25-.676.401 0 .709.13.922.387.214.258.32.587.32.988 0 .245-.045.545-.136.899-.091.354-.211.767-.36 1.238-.148.471-.256.845-.324 1.121-.11.485-.014.902.285 1.254.3.352.694.527 1.184.527.568 0 1.074-.224 1.52-.671.445-.448.787-1.042 1.027-1.782.24-.74.36-1.552.36-2.437 0-1.042-.337-1.89-1.008-2.543-.672-.654-1.607-.98-2.805-.98a4.87 4.87 0 0 0-1.883.359 4.109 4.109 0 0 0-1.441.968 4.462 4.462 0 0 0-1.215 3.063c0 .719.203 1.325.61 1.82a.784.784 0 0 1 .148.242.573.573 0 0 1-.016.258c-.016.084-.078.328-.188.735-.026.12-.08.2-.164.242-.083.041-.182.041-.296 0-.615-.26-1.081-.706-1.399-1.336-.318-.63-.476-1.357-.476-2.18 0-.531.085-1.064.257-1.597a5.604 5.604 0 0 1 .797-1.551c.36-.5.792-.942 1.297-1.324C3.67.887 4.285.58 5.012.348A7.71 7.71 0 0 1 7.367 0z",
            fill: "#FFF",
            fillRule: "evenodd"
        })
    );
});

var TumblrIcon = (function () {
    return React.createElement(
        "svg",
        { width: "11", height: "16" },
        React.createElement("path", {
            d: "M11 15.133a1.39 1.39 0 0 1-.16.094c-.07.036-.224.105-.461.207-.237.101-.487.19-.75.265a8.238 8.238 0 0 1-1.02.207A8.573 8.573 0 0 1 7.336 16c-1.484 0-2.578-.33-3.281-.992C3.352 14.346 3 13.344 3 12V7H.664V4.664a8.2 8.2 0 0 0 1.121-.453c.32-.162.632-.366.934-.613.302-.248.556-.532.761-.852.206-.32.383-.71.532-1.172.148-.46.256-.985.324-1.574h2.328v4h3.672v3H6.664v4c0 .443.026.8.078 1.074.052.274.151.51.297.711.146.2.349.343.61.426.26.083.598.125 1.015.125.297 0 .64-.056 1.027-.168.388-.112.705-.225.95-.34l.359-.164v2.469z",
            fill: "#FFF",
            fillRule: "evenodd"
        })
    );
});

var RedditIcon = (function () {
    return React.createElement(
        "svg",
        { width: "18", height: "15" },
        React.createElement("path", {
            d: "M17.336 6.5c0 .307-.072.594-.215.86a1.882 1.882 0 0 1-.582.656 3.89 3.89 0 0 1-.262 2.668 4.814 4.814 0 0 1-1.093 1.472 7.508 7.508 0 0 1-1.653 1.149 8.882 8.882 0 0 1-2.113.761c-.779.18-1.585.27-2.418.27a10.7 10.7 0 0 1-2.418-.27 8.882 8.882 0 0 1-2.113-.761 7.508 7.508 0 0 1-1.653-1.149 4.814 4.814 0 0 1-1.093-1.472 3.89 3.89 0 0 1-.262-2.668 1.882 1.882 0 0 1-.582-.657A1.783 1.783 0 0 1 .664 6.5c0-.51.178-.944.535-1.3A1.77 1.77 0 0 1 2.5 4.663c.469 0 .875.156 1.219.469a8.756 8.756 0 0 1 2.375-1.067c.89-.257 1.828-.392 2.812-.402L9.946.54a.39.39 0 0 1 .179-.227.398.398 0 0 1 .29-.046l2.75.554c.124-.25.306-.449.546-.597A1.47 1.47 0 0 1 14.5 0c.417 0 .77.146 1.063.438.291.291.437.645.437 1.062 0 .417-.146.77-.438 1.063A1.447 1.447 0 0 1 14.5 3c-.396 0-.737-.134-1.023-.402a1.432 1.432 0 0 1-.47-.98l-2.398-.485-.851 2.562c1.745.12 3.252.6 4.523 1.438a1.75 1.75 0 0 1 1.219-.469c.51 0 .944.178 1.3.535.358.357.536.79.536 1.301zM11.5 9c.323 0 .598-.115.824-.344.227-.229.34-.502.34-.82 0-.323-.113-.599-.34-.828a1.116 1.116 0 0 0-.824-.344c-.323 0-.598.115-.824.344-.227.229-.34.505-.34.828 0 .318.113.591.34.82.226.23.501.344.824.344zM5.336 7.836c0 .318.113.591.34.82.226.23.501.344.824.344.323 0 .598-.115.824-.344.227-.229.34-.502.34-.82 0-.323-.113-.599-.34-.828a1.116 1.116 0 0 0-.824-.344c-.323 0-.598.115-.824.344-.227.229-.34.505-.34.828zm6.43 3.625a.389.389 0 0 0 .136-.25.362.362 0 0 0-.32-.41.368.368 0 0 0-.277.074c-.646.505-1.414.758-2.305.758-.89 0-1.659-.253-2.305-.758a.368.368 0 0 0-.277-.074.362.362 0 0 0-.32.41.389.389 0 0 0 .136.25c.771.604 1.693.906 2.766.906s1.995-.302 2.766-.906z",
            fill: "#FFF",
            fillRule: "evenodd"
        })
    );
});

var _class$3;
var _temp2$2;

var SHARE_ICONS = [{
    type: 'facebook',
    icon: React.createElement(FBIcon, null)
}, {
    type: 'twitter',
    icon: React.createElement(TwitterIcon, null)
}, {
    type: 'pinterest',
    icon: React.createElement(PinterestIcon, null)
}, {
    type: 'tumblr',
    icon: React.createElement(TumblrIcon, null)
}, {
    type: 'reddit',
    icon: React.createElement(RedditIcon, null)
}];
var Share = (_temp2$2 = _class$3 = function (_PureComponent) {
    inherits(Share, _PureComponent);

    function Share() {
        var _ref;

        var _temp, _this, _ret;

        classCallCheck(this, Share);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Share.__proto__ || Object.getPrototypeOf(Share)).call.apply(_ref, [this].concat(args))), _this), _this.linkClipboard = null, _this.embedClipboard = null, _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(Share, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                setMessage$$1 = _props.setMessage,
                reportEvent$$1 = _props.reportEvent;

            /* istanbul ignore next */

            if (this.link) {
                this.linkClipboard = new Clipboard(this.link);
                this.linkClipboard.on('success', function () {
                    reportEvent$$1(ACTIONS.SHARE, 'link');
                    setMessage$$1('GIF link copied!');
                });
            }

            /* istanbul ignore next */
            if (this.embed) {
                this.embedClipboard = new Clipboard(this.embed);
                this.embedClipboard.on('success', function () {
                    reportEvent$$1(ACTIONS.SHARE, 'embed');
                    setMessage$$1('GIF embed code copied!');
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.linkClipboard && this.linkClipboard.destroy();
            this.embedClipboard && this.embedClipboard.destroy();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props2 = this.props,
                gif = _props2.gif,
                reportEvent$$1 = _props2.reportEvent;

            var urls = getSocialUrls(gif);
            return React.createElement(
                'div',
                { className: css$3.container },
                React.createElement(
                    'div',
                    { className: css$3.title },
                    'Share'
                ),
                React.createElement(
                    'div',
                    { className: css$3.subtitle },
                    'Share or embed this GIF!'
                ),
                React.createElement(
                    'div',
                    { className: css$3.buttons },
                    SHARE_ICONS.map(function (_ref2) {
                        var type = _ref2.type,
                            icon = _ref2.icon;
                        return React.createElement(
                            'div',
                            {
                                key: type,
                                className: css$3[type],
                                onClick: function onClick() {
                                    reportEvent$$1(ACTIONS.SHARE, type);
                                    openPopup(urls[type], type);
                                }
                            },
                            icon
                        );
                    }),
                    React.createElement(
                        'div',
                        { ref: function ref(c) {
                                return _this2.link = c;
                            }, className: css$3.link, 'data-clipboard-text': gif.url },
                        React.createElement(LinkIcon, null)
                    ),
                    React.createElement(
                        'div',
                        { ref: function ref(c) {
                                return _this2.embed = c;
                            }, className: css$3.embed, 'data-clipboard-text': getEmbedCode(gif) },
                        React.createElement(EmbedIcon, null)
                    ),
                    React.createElement(
                        'div',
                        {
                            className: css$3.favorite,
                            onClick: function onClick() {
                                reportEvent$$1(ACTIONS.FAVORITE);
                                favoriteGif(gif);
                            }
                        },
                        React.createElement(FavIcon, null)
                    )
                )
            );
        }
    }]);
    return Share;
}(PureComponent), _class$3.propTypes = {
    gif: gifProps.isRequired,
    setMessage: PropTypes.func.isRequired
}, _temp2$2);

var Share$1 = connect(function (_ref3) {
    var gifs$$1 = _ref3.gifs;
    return {
        gif: getCurrentGif(gifs$$1)
    };
}, { setMessage: setMessage, reportEvent: actions.reportEvent })(Share);

var prefix = function prefix(transform) {
    return {
        WebkitTransform: transform,
        MozTransform: transform,
        transform: transform
    };
};

var translate = function translate() {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    return prefix("translate3d(" + x + "px, " + y + "px, " + z + "px)");
};

var CarotIcon = (function (_ref) {
    var className = _ref.className;
    return React.createElement(
        "svg",
        { className: className, xmlns: "http://www.w3.org/2000/svg", height: "7", width: "14" },
        React.createElement("path", {
            fill: "#FFF",
            fillRule: "evenodd",
            d: "M.17.147c0-.032.014-.06.043-.082C.26.022.336 0 .443 0h12.453c.105 0 .182.022.228.065.055.046.06.095.013.147L6.91 6.918c-.047.055-.127.082-.24.082-.116 0-.196-.027-.243-.082L.2.212C.18.185.17.162.17.147z"
        })
    );
});

var css$4 = __$styleInject("._container_njyd4_1 {\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    height: 100%;\r\n    padding: 0;\r\n}\r\n\r\n._label_njyd4_17 {\r\n    font-family: \"nexablack\", sans-serif;\r\n    font-size: 22px;\r\n    font-weight: normal;\r\n    line-height: 50px;\r\n    overflow: hidden;\r\n    margin: 0;\r\n    padding: 0 16px;\r\n    text-overflow: ellipsis;\r\n    text-transform: capitalize;\r\n    white-space: nowrap;\r\n}\r\n._labelClickable_njyd4_41 {\r\n    cursor: pointer;\r\n    -webkit-user-select: none;\r\n       -moz-user-select: none;\r\n        -ms-user-select: none;\r\n            user-select: none;\r\n}\r\n._labelClickable_njyd4_41:active {\r\n        opacity: 0.9;\r\n    }\r\n\r\n._carot_njyd4_61 {\r\n    display: inline-block;\r\n    margin: 22px 0 0 8px;\r\n    vertical-align: top;\r\n}\r\n._carotFlipped_njyd4_71 {\r\n    -webkit-transform: rotate(180deg);\r\n            transform: rotate(180deg);\r\n}", { "container": "_container_njyd4_1", "label": "_label_njyd4_17", "labelClickable": "_labelClickable_njyd4_41 _label_njyd4_17", "carot": "_carot_njyd4_61", "carotFlipped": "_carotFlipped_njyd4_71 _carot_njyd4_61" });

var ChannelLabel = function ChannelLabel(_ref) {
    var channel = _ref.channel,
        channels$$1 = _ref.channels,
        isChangerOn = _ref.isChangerOn,
        setIsChannelChanger$$1 = _ref.setIsChannelChanger;

    var hasChannels = channels$$1 && channels$$1.length > 1;
    return !channel ? null : React.createElement(
        'div',
        { className: css$4.container },
        React.createElement(
            'div',
            {
                className: hasChannels ? css$4.labelClickable : css$4.label,
                onClick: hasChannels ? function () {
                    return setIsChannelChanger$$1(!isChangerOn);
                } : null
            },
            channel.displayName,
            ' TV',
            hasChannels ? React.createElement(CarotIcon, { className: isChangerOn ? css$4.carotFlipped : css$4.carot }) : null
        )
    );
};

var ChannelTitle = connect(function (_ref2) {
    var channels$$1 = _ref2.channels,
        overlay$$1 = _ref2.overlay;
    return {
        channel: getCurrentChannel(channels$$1),
        channels: getChannels(channels$$1),
        isChangerOn: getIsChannelChanger(overlay$$1)
    };
}, { setIsChannelChanger: setIsChannelChanger })(ChannelLabel);

var css$5 = __$styleInject("._channel_5ep1h_1 {\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    cursor: pointer;\r\n    float: left;\r\n    height: 25%;\r\n    padding: 8px;\r\n    position: relative;\r\n    text-transform: capitalize;\r\n    width: 33.33%;\r\n}\r\n\r\n    ._channel_5ep1h_1:active {\r\n        opacity: 0.9;\r\n    }\r\n\r\n._preview_5ep1h_31 {\r\n    background-color: #000;\r\n    background-position: center center;\r\n    background-repeat: no-repeat;\r\n    background-size: cover;\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    height: 100%;\r\n    position: relative;\r\n    width: 100%;\r\n}\r\n\r\n._preview_5ep1h_31:before {\r\n        background: -webkit-gradient(linear,  left top, left bottom,  from(rgba(0, 0, 0, 0.5)), to(rgba(0, 0, 0, 0)));\r\n        background: linear-gradient(to bottom,  rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%);\r\n        bottom: 60%;\r\n        content: \"\";\r\n        left: 0;\r\n        position: absolute;\r\n        right: 0;\r\n        top: 0;\r\n    }\r\n\r\n._preview_5ep1h_31:after {\r\n        background: #000;\r\n        bottom: 0;\r\n        content: \"\";\r\n        left: 0;\r\n        opacity: 0.2;\r\n        position: absolute;\r\n        right: 0;\r\n        top: 0;\r\n    }\r\n._previewActive_5ep1h_93 {\r\n    -webkit-box-shadow: inset 0 0 0 4px #00ccff;\r\n            box-shadow: inset 0 0 0 4px #00ccff;\r\n}\r\n._previewActive_5ep1h_93:before {\r\n        left: 4px;\r\n        right: 4px;\r\n        top: 4px;\r\n    }\r\n._previewActive_5ep1h_93:after {\r\n        bottom: 4px;\r\n        left: 4px;\r\n        right: 4px;\r\n        top: 4px;\r\n    }\r\n\r\n._title_5ep1h_129 {\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    color: #fff;\r\n    display: block;\r\n    font-family: 'interface', sans-serif;\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n    height: 100%;\r\n    left: 0;\r\n    line-height: 16px;\r\n    padding: 24px;\r\n    position: absolute;\r\n    top: 0;\r\n    -webkit-user-select: none;\r\n       -moz-user-select: none;\r\n        -ms-user-select: none;\r\n            user-select: none;\r\n    width: 100%;\r\n}", { "channel": "_channel_5ep1h_1", "preview": "_preview_5ep1h_31", "previewActive": "_previewActive_5ep1h_93 _preview_5ep1h_31", "title": "_title_5ep1h_129" });

var STATIC = 'https://media.giphy.com/media/Yqn9tE2E00k4U/200.gif';
var STATIC_STILL = 'https://media.giphy.com/media/Yqn9tE2E00k4U/200_s.gif';

var ChannelPreview = function ChannelPreview(_ref) {
    var channel$$1 = _ref.channel,
        isActive = _ref.isActive,
        isHidden = _ref.isHidden,
        height = _ref.height,
        width = _ref.width,
        onClick = _ref.onClick;
    var displayName = channel$$1.displayName,
        previewImage = channel$$1.previewImage;

    return React.createElement(
        'div',
        { className: css$5.channel, onClick: onClick, style: { width: width, height: height } },
        React.createElement('div', {
            className: isActive ? css$5.previewActive : css$5.preview,
            style: { backgroundImage: 'url(\'' + (isHidden ? STATIC_STILL : previewImage || STATIC) + '\')' }
        }),
        React.createElement(
            'span',
            { className: css$5.title },
            displayName,
            ' TV'
        )
    );
};

var ChannelGrid = function ChannelGrid(_ref) {
    var className = _ref.className,
        channels = _ref.channels,
        isActive = _ref.isActive,
        activeTerm = _ref.activeTerm,
        previewHeight = _ref.previewHeight,
        previewWidth = _ref.previewWidth,
        _onClick = _ref.onClick;
    return React.createElement(
        'div',
        { className: className },
        channels.map(function (channel, i) {
            return React.createElement(ChannelPreview, {
                key: i,
                channel: channel,
                isHidden: !isActive,
                isActive: channel.term === activeTerm,
                height: previewHeight,
                width: previewWidth,
                onClick: function onClick() {
                    return _onClick(i);
                }
            });
        })
    );
};

var css$6 = __$styleInject("._container_12uq1_1 {\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    height: 40px;\r\n    margin: 0;\r\n    padding: 8px 16px;\r\n    text-align: right;\r\n    width: 100%;\r\n}\r\n\r\n._button_12uq1_19 {\r\n    background: #3e3e3e;\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    cursor: pointer;\r\n    display: inline-block;\r\n    height: 24px;\r\n    line-height: 26px;\r\n    margin-left: 3px;\r\n    text-align: center;\r\n    width: 36px;\r\n}\r\n\r\n._button_12uq1_19 > svg {\r\n        display: inline-block;\r\n        height: 12px;\r\n    }\r\n\r\n._button_12uq1_19:active {\r\n        opacity: 0.9;\r\n    }\r\n\r\n._buttonDisabled_12uq1_61 {\r\n    opacity: 0.5;\r\n    pointer-events: none;\r\n}\r\n", { "container": "_container_12uq1_1", "button": "_button_12uq1_19", "buttonDisabled": "_buttonDisabled_12uq1_61 _button_12uq1_19" });

var NextIcon$1 = function NextIcon() {
    return React.createElement(
        "svg",
        { viewBox: "0 0 11 17", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", {
            d: "M10.007 8.252l.278-.277L2.25-.06l-2 2 6.311 6.311-6.31 6.311 2 2 8.033-8.034-.278-.277z",
            fill: "#FFF",
            fillRule: "evenodd"
        })
    );
};

var PreviousIcon$1 = function PreviousIcon() {
    return React.createElement(
        "svg",
        { viewBox: "0 0 11 17", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", {
            d: "M.597 8.748l-.219.218L8.412 17l1.882-1.882-6.37-6.37 6.37-6.37L8.412.496.378 8.529l.219.219z",
            fill: "#FFF",
            fillRule: "evenodd"
        })
    );
};

var Navigation = (function (_ref) {
    var page = _ref.page,
        totalPages = _ref.totalPages,
        _onClick = _ref.onClick;
    return React.createElement(
        "div",
        { className: css$6.container },
        React.createElement(
            "div",
            { className: page > 0 ? css$6.button : css$6.buttonDisabled, onClick: function onClick() {
                    return _onClick(page - 1);
                } },
            React.createElement(PreviousIcon$1, null)
        ),
        React.createElement(
            "div",
            { className: page < totalPages - 1 ? css$6.button : css$6.buttonDisabled, onClick: function onClick() {
                    return _onClick(page + 1);
                } },
            React.createElement(NextIcon$1, null)
        )
    );
});

var padding = "8px";
var headerHeight = "90px";





var css$7 = __$styleInject("._container_1a4y9_7 {\r\n    -webkit-box-align: start;\r\n        -ms-flex-align: start;\r\n            align-items: flex-start;\r\n    -ms-flex-item-align: start;\r\n        align-self: flex-start;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: column;\r\n            flex-direction: column;\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n\r\n._header_1a4y9_25 {\r\n    height: 50px;\r\n    margin-right: 50px;\r\n}\r\n\r\n._pagesWrapper_1a4y9_35 {\r\n    height: 100%;\r\n    overflow: hidden;\r\n    width: 100%;\r\n}\r\n\r\n._pages_1a4y9_35 {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    height: 100%;\r\n}\r\n\r\n._page_1a4y9_35 {\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    -ms-flex-negative: 0;\r\n        flex-shrink: 0;\r\n    height: 100%;\r\n    padding: 8px;\r\n    width: 100%;\r\n}\r\n\r\n._page_1a4y9_35[data-swiped=\"true\"] {\r\n        -webkit-transition: -webkit-transform .1s ease-out;\r\n        transition: -webkit-transform .1s ease-out;\r\n        transition: transform .1s ease-out;\r\n        transition: transform .1s ease-out, -webkit-transform .1s ease-out;\r\n    }\r\n\r\n._page_1a4y9_35:after {\r\n        clear: both;\r\n        content: \"\";\r\n        display: block;\r\n    }\r\n._header_1a4y9_25 + ._page_1a4y9_35 {\r\n    margin-top: 40px;\r\n}\r\n", { "padding": "8px", "headerHeight": "90px", "container": "_container_1a4y9_7", "header": "_header_1a4y9_25", "pagesWrapper": "_pagesWrapper_1a4y9_35", "pages": "_pages_1a4y9_35", "page": "_page_1a4y9_35" });

var MAX_WIDTH = 500;
var PADDING = parseInt(padding);

var getChannelSize = function getChannelSize(_ref) {
    var width = _ref.width,
        height = _ref.height;

    var maxWidth = width - PADDING * 2;
    var maxHeight = height - PADDING * 2 - parseInt(headerHeight);
    var columns = Math.max(2, Math.ceil(maxWidth / MAX_WIDTH));
    var newWidth = Math.floor(maxWidth / columns);
    var newHeight = Math.round(newWidth * 0.5625);
    var rows = Math.max(1, Math.floor(maxHeight / newHeight));
    return {
        width: newWidth,
        height: newHeight,
        columns: columns,
        rows: rows
    };
};

var _dec$2;
var _class$4;
var _class2$2;
var _temp2$3;

var ChannelChanger = (_dec$2 = connect(function (_ref) {
    var channels$$1 = _ref.channels,
        dimensions$$1 = _ref.dimensions;
    return {
        channels: getChannels(channels$$1),
        currentChannel: getCurrentChannel(channels$$1),
        width: getWidth(dimensions$$1),
        height: getHeight(dimensions$$1)
    };
}, { changeChannel: actions.changeChannel, setIsSubsection: setIsSubsection, reportEvent: actions.reportEvent }), _dec$2(_class$4 = (_temp2$3 = _class2$2 = function (_PureComponent) {
    inherits(ChannelChanger, _PureComponent);

    function ChannelChanger() {
        var _ref2;

        var _temp, _this, _ret;

        classCallCheck(this, ChannelChanger);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref2 = ChannelChanger.__proto__ || Object.getPrototypeOf(ChannelChanger)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
            previewWidth: 0,
            previewHeight: 0,
            currentPage: 1,
            peekPage: 1,
            totalPages: 0,
            minChannel: 0,
            maxChannel: 0,
            swipeX: 0,
            isSwiped: false
        }, _this.isSwipeBack = false, _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(ChannelChanger, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.updateGrid();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var _props = this.props,
                width = _props.width,
                height = _props.height;

            if (prevProps.width !== width || prevProps.height !== height) {
                this.updateGrid();
            }
        }
    }, {
        key: 'updateGrid',
        value: function updateGrid() {
            var channels$$1 = this.props.channels;

            var _getChannelSize = getChannelSize(this.props),
                width = _getChannelSize.width,
                height = _getChannelSize.height,
                rows = _getChannelSize.rows,
                columns = _getChannelSize.columns;

            var maxChannels = columns * rows;
            var totalPages = Math.ceil(channels$$1.length / maxChannels);
            this.setState({ maxChannels: maxChannels, totalPages: totalPages, previewWidth: width, previewHeight: height, currentPage: 0 });
        }
    }, {
        key: 'onSwiping',
        value: function onSwiping(x) {
            var _state = this.state,
                currentPage = _state.currentPage,
                totalPages = _state.totalPages;

            var isBack = x > 0;
            var swipeX = x;
            var peekPage = currentPage;
            // add friction if swiping to page that doesn't exist
            if (isBack && currentPage === 0 || !isBack && currentPage === totalPages - 1) {
                swipeX *= 0.5;
            } else if (Math.abs(x) > 0) {
                peekPage = currentPage + (isBack ? -1 : 1);
            }
            this.isSwipeBack = isBack;
            this.setState({ swipeX: swipeX, peekPage: peekPage, isSwiped: false });
        }
    }, {
        key: 'onSwiped',
        value: function onSwiped(deltaX, deltaY, isFlick) {
            var width = this.props.width;
            var _state2 = this.state,
                currentPage = _state2.currentPage,
                totalPages = _state2.totalPages;

            var isSwipe = isFlick || deltaX > width / 2;
            var nextPage = isSwipe ? this.isSwipeBack ? currentPage - 1 : currentPage + 1 : currentPage;
            nextPage = Math.max(0, Math.min(nextPage, totalPages - 1));
            this.setState({ currentPage: nextPage, swipeX: 0, isSwiped: true });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props2 = this.props,
                width = _props2.width,
                channels$$1 = _props2.channels,
                currentChannel = _props2.currentChannel,
                changeChannel$$1 = _props2.changeChannel,
                setIsSubsection$$1 = _props2.setIsSubsection,
                reportEvent$$1 = _props2.reportEvent;
            var _state3 = this.state,
                previewWidth = _state3.previewWidth,
                previewHeight = _state3.previewHeight,
                maxChannels = _state3.maxChannels,
                currentPage = _state3.currentPage,
                peekPage = _state3.peekPage,
                totalPages = _state3.totalPages,
                swipeX = _state3.swipeX,
                isSwiped = _state3.isSwiped;

            var hasPages = totalPages > 1;
            var pages$$1 = hasPages ? chunk(channels$$1, maxChannels) : [channels$$1];
            return React.createElement(
                'div',
                { className: css$7.container },
                React.createElement(
                    'div',
                    { className: css$7.header },
                    React.createElement(ChannelTitle, null)
                ),
                hasPages && React.createElement(Navigation, {
                    page: currentPage,
                    totalPages: totalPages,
                    onClick: function onClick(currentPage) {
                        return _this2.setState({ currentPage: currentPage });
                    }
                }),
                React.createElement(
                    Swipeable,
                    {
                        className: css$7.pagesWrapper,
                        disabled: totalPages < 2,
                        preventDefaultTouchmoveEvent: true,
                        stopPropagation: true,
                        onSwipingLeft: function onSwipingLeft(e, x) {
                            return _this2.onSwiping(-x);
                        },
                        onSwipingRight: function onSwipingRight(e, x) {
                            return _this2.onSwiping(x);
                        },
                        onSwiped: function onSwiped(e, x, y, isFlick) {
                            return _this2.onSwiped(x, y, isFlick);
                        }
                    },
                    React.createElement(
                        'div',
                        { className: css$7.pages, 'data-swiped': isSwiped, style: translate(swipeX - width * currentPage) },
                        pages$$1.map(function (channels$$1, i) {
                            return React.createElement(ChannelGrid, {
                                key: i,
                                className: css$7.page,
                                channels: channels$$1,
                                activeTerm: currentChannel.term,
                                previewHeight: previewHeight,
                                previewWidth: previewWidth,
                                isActive: i === currentPage || i === peekPage,
                                onClick: function onClick(channelIndex) {
                                    // term is an id, or it's a term
                                    reportEvent$$1(ACTIONS.CHANGE_CHANNEL, channels$$1[channelIndex].term);
                                    changeChannel$$1(channelIndex + i * maxChannels);
                                    setIsSubsection$$1(false);
                                }
                            });
                        })
                    )
                )
            );
        }
    }]);
    return ChannelChanger;
}(PureComponent), _class2$2.propTypes = {
    channels: PropTypes.array.isRequired,
    currentChannel: PropTypes.object,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    changeChannel: PropTypes.func.isRequired,
    setIsSubsection: PropTypes.func.isRequired
}, _temp2$3)) || _class$4);

var css$8 = __$styleInject("._close_99nx2_1 {\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    cursor: pointer;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    height: 50px;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    position: absolute;\r\n    right: 0;\r\n    top: 0;\r\n    width: 50px;\r\n}\r\n\r\n    ._close_99nx2_1:active {\r\n        opacity: 0.78;\r\n    }", { "close": "_close_99nx2_1" });

var IS_MOBILE$1 = isMobile();

var CloseButton = function CloseButton(_ref) {
    var setIsSubsection$$1 = _ref.setIsSubsection;
    return React.createElement(
        'div',
        { className: css$8.close, 'data-fatfingers': IS_MOBILE$1, onClick: function onClick() {
                return setIsSubsection$$1(false);
            } },
        React.createElement(
            'svg',
            { width: '14', height: '14', xmlns: 'http://www.w3.org/2000/svg' },
            React.createElement('path', {
                d: 'M13.93 11.094L9.836 7l4.094-4.094a.382.382 0 0 0 .086-.242.36.36 0 0 0-.086-.234L11.57.07a.36.36 0 0 0-.234-.086.382.382 0 0 0-.242.086L7 4.164 2.906.07a.382.382 0 0 0-.242-.086.36.36 0 0 0-.234.086L.07 2.43a.36.36 0 0 0-.086.234c0 .094.032.172.086.242L4.164 7 .07 11.094a.382.382 0 0 0-.086.242.36.36 0 0 0 .086.234l2.36 2.36a.36.36 0 0 0 .234.086.382.382 0 0 0 .242-.086L7 9.836l4.094 4.094c.07.054.148.086.242.086a.36.36 0 0 0 .234-.086l2.36-2.36a.36.36 0 0 0 .086-.234.382.382 0 0 0-.086-.242z',
                fill: '#F7F7F7',
                fillRule: 'evenodd'
            })
        )
    );
};

var CloseIcon = connect(null, { setIsSubsection: setIsSubsection })(CloseButton);

var css$9 = __$styleInject("._container_7bjct_7 {\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    font-family: \"interface\", sans-serif;\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n    height: 100%;\r\n    left: 0;\r\n    padding: 0;\r\n    position: absolute;\r\n    top: 0;\r\n    width: 100%;\r\n    z-index: 10;\r\n}._container_7bjct_7 div[data-fatfingers=\"true\"] {\r\n        height: 50px;\r\n        opacity: 1;\r\n        width: 50px;\r\n    }._containerHidden_7bjct_45 {\r\n    pointer-events: none;\r\n}._wrapper_7bjct_55 {\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    height: 100%;\r\n    padding: 68px 0;\r\n    position: relative;\r\n    width: 100%;\r\n}._wrapperHidden_7bjct_69 ._header_7bjct_75 {\r\n        -webkit-transform: translate3d(0, -100px, 0);\r\n                transform: translate3d(0, -100px, 0);\r\n    }._wrapperHidden_7bjct_69 ._footer_7bjct_83 {\r\n        -webkit-transform: translate3d(0, 100px, 0);\r\n                transform: translate3d(0, 100px, 0);\r\n    }._wrapperHidden_7bjct_69 ._subsection_7bjct_91 {\r\n        opacity: 0;\r\n        pointer-events: none;\r\n    }._wrapperHidden_7bjct_69 ._gifLink_7bjct_101 {\r\n        display: none;\r\n    }._gifLink_7bjct_101 {\r\n    display: block;\r\n    height: 100%;\r\n    width: 100%;\r\n}._header_7bjct_75 {\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    height: 50px;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    left: 0;\r\n    position: absolute;\r\n    top: 0;\r\n    -webkit-transition: -webkit-transform .25s ease-out;\r\n    transition: -webkit-transform .25s ease-out;\r\n    transition: transform .25s ease-out;\r\n    transition: transform .25s ease-out, -webkit-transform .25s ease-out;\r\n    width: 100%;\r\n    z-index: 2;\r\n}._header_7bjct_75:before {\r\n        background: -webkit-gradient(linear,  left top, left bottom,  from(rgba(0, 0, 0, 0.5)), to(rgba(0, 0, 0, 0)));\r\n        background: linear-gradient(to bottom,  rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%);\r\n        content: \"\";\r\n        left: 0;\r\n        height: 90px;\r\n        pointer-events: none;\r\n        position: absolute;\r\n        top: -1px;\r\n        width: 100%;\r\n        z-index: -1;\r\n    }._headerPadded_7bjct_171 {\r\n    padding-right: 50px;\r\n}._footer_7bjct_83 {\r\n    bottom: 0;\r\n    height: 68px;\r\n    top: auto;\r\n}._footer_7bjct_83:before {\r\n        background: -webkit-gradient(linear,  left top, left bottom,  from(rgba(0, 0, 0, 0)), to(rgba(0, 0, 0, 0.5)));\r\n        background: linear-gradient(to bottom,  rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);\r\n        bottom: -1px;\r\n        top: auto;\r\n    }._subsection_7bjct_91 {\r\n    -webkit-animation: _subIn_7bjct_1 .25s ease-out;\r\n            animation: _subIn_7bjct_1 .25s ease-out;\r\n    background: rgba(0, 0, 0, 0.85);\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    height: 100%;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    left: 0;\r\n    position: absolute;\r\n    top: 0;\r\n    -webkit-transition: opacity .25s ease-out;\r\n    transition: opacity .25s ease-out;\r\n    width: 100%;\r\n}._button_7bjct_233 {\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    cursor: pointer;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-flex: 0;\r\n        -ms-flex-positive: 0;\r\n            flex-grow: 0;\r\n    -ms-flex-negative: 0;\r\n        flex-shrink: 0;\r\n    height: 36px;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    opacity: 0.88;\r\n    width: 36px;\r\n}._button_7bjct_233:hover {\r\n        opacity: 1;\r\n    }._button_7bjct_233:active {\r\n        opacity: 0.78;\r\n    }@-webkit-keyframes _subIn_7bjct_1 {\r\n    0% { opacity: 0; }\r\n    100% { opacity: 1; }\r\n}@keyframes _subIn_7bjct_1 {\r\n    0% { opacity: 0; }\r\n    100% { opacity: 1; }\r\n}._button_y0wum_1 {\r\n}", { "button": "_button_y0wum_1 _button_7bjct_233" });

var SUPPORTS_FULLSCREEN = document && (document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled);

var Icon = function Icon() {
    return React.createElement(
        'svg',
        { width: '18', height: '18', xmlns: 'http://www.w3.org/2000/svg' },
        React.createElement('path', {
            d: 'M8.885 12.063l-2.953 2.98 2.354 2.358c.077.06.115.142.115.246a.34.34 0 0 1-.102.25.34.34 0 0 1-.25.103H.352a.34.34 0 0 1-.25-.103.34.34 0 0 1-.103-.25V9.944c0-.164.071-.276.213-.336.17-.039.298-.011.386.082l2.355 2.373 2.978-2.956A.338.338 0 0 1 6.178 9c.093 0 .172.036.238.107l2.47 2.471c.076.055.114.14.114.255a.266.266 0 0 1-.115.23zM18 .353v7.695c0 .164-.071.277-.213.337a.414.414 0 0 1-.385-.082l-2.353-2.371-2.975 2.978a.31.31 0 0 1-.23.09.343.343 0 0 1-.254-.09L9.098 6.416A.324.324 0 0 1 9 6.178c0-.093.033-.175.098-.246l2.976-2.978L9.704.599C9.613.51 9.585.383 9.624.213 9.683.071 9.795 0 9.959 0h7.689a.34.34 0 0 1 .25.103.34.34 0 0 1 .102.25z',
            fill: '#FFF',
            fillRule: 'evenodd'
        })
    );
};

var IconClose = function IconClose() {
    return React.createElement(
        'svg',
        { width: '23', height: '23', xmlns: 'http://www.w3.org/2000/svg' },
        React.createElement('path', {
            d: 'M10.895 12.532v9.316c0 .199-.086.334-.258.407a.502.502 0 0 1-.467-.1l-2.847-2.87-3.602 3.606a.376.376 0 0 1-.278.109.416.416 0 0 1-.308-.11L.12 19.873a.393.393 0 0 1-.12-.289c0-.113.04-.212.12-.298l3.6-3.605-2.867-2.85c-.112-.107-.145-.262-.099-.468.073-.172.208-.258.407-.258h9.307c.12 0 .22.042.303.124a.412.412 0 0 1 .124.303zm1.21-2.064V1.152c0-.199.086-.334.258-.407a.502.502 0 0 1 .467.1l2.847 2.87L19.28.108A.376.376 0 0 1 19.557 0c.132 0 .235.036.308.11l3.016 3.018c.08.08.119.176.119.288 0 .113-.04.212-.12.298l-3.6 3.605 2.867 2.85c.112.107.145.262.099.468-.073.172-.208.258-.407.258h-9.307a.412.412 0 0 1-.303-.124.412.412 0 0 1-.124-.303z',
            fill: '#FFF',
            fillRule: 'evenodd'
        })
    );
};

var FullscreenButton = function FullscreenButton(_ref) {
    var isFullscreen = _ref.isFullscreen,
        setIsFullscreen$$1 = _ref.setIsFullscreen;
    return SUPPORTS_FULLSCREEN ? React.createElement(
        'div',
        { className: css$9.button, 'data-fatfingers': true, onClick: function onClick() {
                return setIsFullscreen$$1(!isFullscreen);
            } },
        isFullscreen ? React.createElement(IconClose, null) : React.createElement(Icon, null)
    ) : null;
};

var FullscreenIcon = connect(function (_ref2) {
    var overlay$$1 = _ref2.overlay;
    return {
        isFullscreen: getIsFullscreen(overlay$$1)
    };
}, { setIsFullscreen: setIsFullscreen })(FullscreenButton);

var css$10 = __$styleInject("._message_x0lt8_1 {\r\n    background: #00ff99;\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    color: #000;\r\n    font-family: \"interface\", sans-serif;\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n    height: 50px;\r\n    left: 0;\r\n    line-height: 50px;\r\n    padding: 0 16px;\r\n    pointer-events: none;\r\n    position: absolute;\r\n    top: 0;\r\n    -webkit-transition: -webkit-transform .2s ease-out;\r\n    transition: -webkit-transform .2s ease-out;\r\n    transition: transform .2s ease-out;\r\n    transition: transform .2s ease-out, -webkit-transform .2s ease-out;\r\n    width: 100%;\r\n}\r\n\r\n    ._message_x0lt8_1[data-hidemessage=\"true\"] {\r\n        -webkit-transform: translate3d(0, -50px, 0);\r\n                transform: translate3d(0, -50px, 0);\r\n    }\r\n._errorMessage_x0lt8_43 {\r\n    background: #ff6666;\r\n}", { "message": "_message_x0lt8_1", "errorMessage": "_errorMessage_x0lt8_43 _message_x0lt8_1" });

var _class$5;
var _temp2$4;

var DELAY = 2000;
var Message = (_temp2$4 = _class$5 = function (_PureComponent) {
    inherits(Message, _PureComponent);

    function Message() {
        var _ref;

        var _temp, _this, _ret;

        classCallCheck(this, Message);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Message.__proto__ || Object.getPrototypeOf(Message)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            show: false
        }, _this.showDelay = null, _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(Message, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var message$$1 = this.props.message;

            if (message$$1 && message$$1 !== prevProps.message) {
                this.showMessage();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearTimeout(this.showDelay);
        }
    }, {
        key: 'showMessage',
        value: function showMessage() {
            var _this2 = this;

            clearTimeout(this.showDelay);
            this.setState({ show: true }, function () {
                _this2.showDelay = setTimeout(function () {
                    return _this2.hideMessage();
                }, DELAY);
            });
        }
    }, {
        key: 'hideMessage',
        value: function hideMessage() {
            this.setState({ show: false });
            this.props.setMessage('');
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                message$$1 = _props.message,
                isError = _props.isError;
            var show = this.state.show;

            return React.createElement(
                'div',
                { className: isError ? css$10.errorMessage : css$10.message, 'data-hidemessage': !show },
                message$$1
            );
        }
    }]);
    return Message;
}(PureComponent), _class$5.propTypes = {
    message: PropTypes.string,
    isError: PropTypes.bool,
    setMessage: PropTypes.func
}, _class$5.defaultProps = {
    message: '',
    isError: false
}, _temp2$4);

var Message$1 = connect(function (_ref2) {
    var overlay$$1 = _ref2.overlay;
    return {
        message: getMessage(overlay$$1),
        isError: getIsErrorMessage(overlay$$1)
    };
}, { setMessage: setMessage })(Message);

var headerHeight$1 = "50px";
var footerHeight = "68px";











var css$11 = __$styleInject("._container_7bjct_7 {\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    font-family: \"interface\", sans-serif;\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n    height: 100%;\r\n    left: 0;\r\n    padding: 0;\r\n    position: absolute;\r\n    top: 0;\r\n    width: 100%;\r\n    z-index: 10;\r\n}\r\n._container_7bjct_7 div[data-fatfingers=\"true\"] {\r\n        height: 50px;\r\n        opacity: 1;\r\n        width: 50px;\r\n    }\r\n._containerHidden_7bjct_45 {\r\n    pointer-events: none;\r\n}\r\n\r\n._wrapper_7bjct_55 {\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    height: 100%;\r\n    padding: 68px 0;\r\n    position: relative;\r\n    width: 100%;\r\n}\r\n._wrapperHidden_7bjct_69 ._header_7bjct_75 {\r\n        -webkit-transform: translate3d(0, -100px, 0);\r\n                transform: translate3d(0, -100px, 0);\r\n    }\r\n._wrapperHidden_7bjct_69 ._footer_7bjct_83 {\r\n        -webkit-transform: translate3d(0, 100px, 0);\r\n                transform: translate3d(0, 100px, 0);\r\n    }\r\n._wrapperHidden_7bjct_69 ._subsection_7bjct_91 {\r\n        opacity: 0;\r\n        pointer-events: none;\r\n    }\r\n._wrapperHidden_7bjct_69 ._gifLink_7bjct_101 {\r\n        display: none;\r\n    }\r\n\r\n._gifLink_7bjct_101 {\r\n    display: block;\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n\r\n._header_7bjct_75 {\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    height: 50px;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    left: 0;\r\n    position: absolute;\r\n    top: 0;\r\n    -webkit-transition: -webkit-transform .25s ease-out;\r\n    transition: -webkit-transform .25s ease-out;\r\n    transition: transform .25s ease-out;\r\n    transition: transform .25s ease-out, -webkit-transform .25s ease-out;\r\n    width: 100%;\r\n    z-index: 2;\r\n}\r\n\r\n._header_7bjct_75:before {\r\n        background: -webkit-gradient(linear,  left top, left bottom,  from(rgba(0, 0, 0, 0.5)), to(rgba(0, 0, 0, 0)));\r\n        background: linear-gradient(to bottom,  rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%);\r\n        content: \"\";\r\n        left: 0;\r\n        height: 90px;\r\n        pointer-events: none;\r\n        position: absolute;\r\n        top: -1px;\r\n        width: 100%;\r\n        z-index: -1;\r\n    }\r\n._headerPadded_7bjct_171 {\r\n    padding-right: 50px;\r\n}\r\n\r\n._footer_7bjct_83 {\r\n    bottom: 0;\r\n    height: 68px;\r\n    top: auto;\r\n}\r\n\r\n._footer_7bjct_83:before {\r\n        background: -webkit-gradient(linear,  left top, left bottom,  from(rgba(0, 0, 0, 0)), to(rgba(0, 0, 0, 0.5)));\r\n        background: linear-gradient(to bottom,  rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);\r\n        bottom: -1px;\r\n        top: auto;\r\n    }\r\n\r\n._subsection_7bjct_91 {\r\n    -webkit-animation: _subIn_7bjct_1 .25s ease-out;\r\n            animation: _subIn_7bjct_1 .25s ease-out;\r\n    background: rgba(0, 0, 0, 0.85);\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    height: 100%;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    left: 0;\r\n    position: absolute;\r\n    top: 0;\r\n    -webkit-transition: opacity .25s ease-out;\r\n    transition: opacity .25s ease-out;\r\n    width: 100%;\r\n}\r\n\r\n._button_7bjct_233 {\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    cursor: pointer;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-flex: 0;\r\n        -ms-flex-positive: 0;\r\n            flex-grow: 0;\r\n    -ms-flex-negative: 0;\r\n        flex-shrink: 0;\r\n    height: 36px;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    opacity: 0.88;\r\n    width: 36px;\r\n}\r\n\r\n._button_7bjct_233:hover {\r\n        opacity: 1;\r\n    }\r\n\r\n._button_7bjct_233:active {\r\n        opacity: 0.78;\r\n    }\r\n\r\n@-webkit-keyframes _subIn_7bjct_1 {\r\n    0% { opacity: 0; }\r\n    100% { opacity: 1; }\r\n}\r\n\r\n@keyframes _subIn_7bjct_1 {\r\n    0% { opacity: 0; }\r\n    100% { opacity: 1; }\r\n}", { "headerHeight": "50px", "footerHeight": "68px", "container": "_container_7bjct_7", "containerHidden": "_containerHidden_7bjct_45 _container_7bjct_7", "wrapper": "_wrapper_7bjct_55", "wrapperHidden": "_wrapperHidden_7bjct_69 _wrapper_7bjct_55", "header": "_header_7bjct_75", "footer": "_footer_7bjct_83 _header_7bjct_75", "subsection": "_subsection_7bjct_91", "gifLink": "_gifLink_7bjct_101", "headerPadded": "_headerPadded_7bjct_171 _header_7bjct_75", "subIn": "_subIn_7bjct_1", "button": "_button_7bjct_233" });

var OverlayContent = function OverlayContent(_ref) {
    var gif = _ref.gif,
        isFullscreen = _ref.isFullscreen,
        isHidden = _ref.isHidden,
        isCutoutHidden = _ref.isCutoutHidden,
        reportEvent$$1 = _ref.reportEvent;
    return React.createElement(
        'div',
        { className: isHidden ? css$11.wrapperHidden : css$11.wrapper },
        !isFullscreen && gif && React.createElement('a', {
            className: css$11.gifLink,
            href: gif.url,
            target: '_blank',
            'data-tap': true,
            onClick: function onClick() {
                reportEvent$$1(ACTIONS.CLICK_THROUGH);
            }
        }),
        React.createElement(
            'div',
            { className: isCutoutHidden ? css$11.header : css$11.headerPadded },
            React.createElement(ChannelTitle, null),
            React.createElement(ShareIcon, null),
            ' ',
            isCutoutHidden && React.createElement(FullscreenIcon, null)
        ),
        React.createElement(
            'div',
            { className: css$11.footer },
            React.createElement(Attribution$1, { key: gif ? gif.id : null }),
            React.createElement(Controls$1, null)
        )
    );
};
OverlayContent = connect(undefined, { reportEvent: actions.reportEvent })(OverlayContent);

var Overlay = function Overlay(_ref2) {
    var gif = _ref2.gif,
        isOn = _ref2.isOn,
        isShare = _ref2.isShare,
        isFullscreen = _ref2.isFullscreen,
        isChannelChanger = _ref2.isChannelChanger,
        isSubsection = _ref2.isSubsection,
        isCutoutHidden = _ref2.isCutoutHidden;
    return React.createElement(
        'div',
        { className: !isOn ? css$11.containerHidden : css$11.container },
        isSubsection ? React.createElement(
            'div',
            { className: css$11.subsection },
            isShare && React.createElement(Share$1, null),
            isChannelChanger && React.createElement(ChannelChanger, null),
            React.createElement(CloseIcon, null)
        ) : React.createElement(OverlayContent, { gif: gif, isFullscreen: isFullscreen, isHidden: !isOn, isCutoutHidden: isCutoutHidden }),
        React.createElement(Message$1, null)
    );
};

var Overlay$1 = connect(function (_ref3) {
    var gifs$$1 = _ref3.gifs,
        overlay$$1 = _ref3.overlay,
        options$$1 = _ref3.options;
    return {
        gif: getCurrentGif(gifs$$1),
        isOn: getIsOverlayOn(overlay$$1),
        isCutoutHidden: getIsCutoutHidden(options$$1),
        isShare: getIsShare(overlay$$1),
        isFullscreen: getIsFullscreen(overlay$$1),
        isChannelChanger: getIsChannelChanger(overlay$$1),
        isSubsection: getIsSubsection(overlay$$1)
    };
})(Overlay);

var css$12 = __$styleInject("._swipe_tc85f_1 {\r\n    background: #000;\r\n    height: 100%;\r\n    overflow: hidden;\r\n    position: absolute;\r\n    width: 100%;\r\n    z-index: 9;\r\n}\r\n\r\n._preview_tc85f_19 {\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    background-position: center center;\r\n    background-repeat: no-repeat;\r\n    background-size: cover;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    height: 100%;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    position: absolute;\r\n    width: 100%;\r\n}\r\n\r\n._preview_tc85f_19[data-label=\"true\"]:before {\r\n        background: #000;\r\n        content: \"\";\r\n        height: 100%;\r\n        left: 0;\r\n        opacity: 0.5;\r\n        position: absolute;\r\n        top: 0;\r\n        width: 100%;\r\n    }\r\n\r\n._preview_tc85f_19[data-letterbox=\"true\"] {\r\n        background-size: contain;\r\n    }\r\n\r\n._label_tc85f_73 {\r\n    font-family: \"nexablack\", sans-serif;\r\n    font-weight: normal;\r\n    font-size: 30px;\r\n    padding: 20px;\r\n    position: relative;\r\n    text-align: center;\r\n    text-transform: capitalize;\r\n}\r\n\r\n._next_tc85f_93 {\r\n    left: 100%;\r\n    top: 0;\r\n}\r\n\r\n._next_tc85f_93 ._preview_tc85f_19 {\r\n        bottom: 0;\r\n        right: 100%;\r\n    }\r\n\r\n._next_tc85f_93[data-vertical=\"true\"] {\r\n        left: 0;\r\n        top: 100%;\r\n    }\r\n\r\n._next_tc85f_93[data-vertical=\"true\"] ._preview_tc85f_19 {\r\n            bottom: 100%;\r\n            right: 0;\r\n        }\r\n._previous_tc85f_133 {\r\n    bottom: 0;\r\n    right: 100%;\r\n}\r\n._previous_tc85f_133 ._preview_tc85f_19 {\r\n        left: 100%;\r\n        top: 0;\r\n    }\r\n._previous_tc85f_133[data-vertical=\"true\"] {\r\n        bottom: 100%;\r\n        right: 0;\r\n    }\r\n._previous_tc85f_133[data-vertical=\"true\"] ._preview_tc85f_19 {\r\n            left: 0;\r\n            top: 100%;\r\n        }", { "swipe": "_swipe_tc85f_1", "preview": "_preview_tc85f_19", "label": "_label_tc85f_73", "next": "_next_tc85f_93 _swipe_tc85f_1", "previous": "_previous_tc85f_133 _swipe_tc85f_1" });

var Peeker = function Peeker(_ref) {
    var x = _ref.x,
        y = _ref.y,
        width = _ref.width,
        height = _ref.height,
        previewImage = _ref.previewImage,
        previewLabel = _ref.previewLabel,
        isVertical = _ref.isVertical,
        isSwiped = _ref.isSwiped,
        isLetterbox = _ref.isLetterbox;

    var isBack = x > 0 || y > 0;
    var translateX = x * width;
    var translateY = y * height;
    return React.createElement(
        'div',
        {
            className: isBack ? css$12.previous : css$12.next,
            'data-swiped': isSwiped,
            'data-vertical': isVertical,
            style: translate(translateX, translateY)
        },
        React.createElement(
            'div',
            {
                className: css$12.preview,
                'data-letterbox': !isVertical && isLetterbox,
                'data-label': previewLabel.length > 0,
                'data-swiped': isSwiped,
                style: _extends({
                    backgroundImage: 'url(' + previewImage + ')'
                }, translate(-translateX, -translateY))
            },
            previewLabel && React.createElement(
                'span',
                { className: css$12.label },
                previewLabel,
                ' TV'
            )
        )
    );
};

var Peeker$1 = connect(function (_ref2) {
    var dimensions$$1 = _ref2.dimensions,
        swiping$$1 = _ref2.swiping,
        options$$1 = _ref2.options;
    return {
        x: getSwipeX(swiping$$1),
        y: getSwipeY(swiping$$1),
        width: getWidth(dimensions$$1),
        height: getHeight(dimensions$$1),
        previewImage: getSwipePreview(swiping$$1),
        previewLabel: getSwipeLabel(swiping$$1),
        isVertical: getIsVertical(swiping$$1),
        isSwiped: getIsSwiped(swiping$$1),
        isLetterbox: getIsLetterbox(options$$1)
    };
})(Peeker);

var css$13 = __$styleInject("._container_1w7ss_1 {\r\n    height: 100%;\r\n    overflow: hidden;\r\n    width: 100%;\r\n}", { "container": "_container_1w7ss_1" });

var _dec$3;
var _class$6;
var _class2$3;
var _temp2$5;

var SWIPE_DURATION = 200;
var TV_BARS = 'https://media.giphy.com/media/Yqn9tE2E00k4U/200.gif';

var Changer = (_dec$3 = connect(function (_ref) {
    var gifs$$1 = _ref.gifs,
        dimensions$$1 = _ref.dimensions,
        channels$$1 = _ref.channels,
        swiping$$1 = _ref.swiping,
        overlay$$1 = _ref.overlay;
    return {
        gif: getCurrentGif(gifs$$1),
        nextGif: getNextGif(gifs$$1),
        previousGif: getPreviousGif(gifs$$1),
        width: getWidth(dimensions$$1),
        height: getHeight(dimensions$$1),
        availableChannels: getChannels(channels$$1),
        currentChannelIndex: getCurrentChannelIndex(channels$$1),
        isSubsection: getIsSubsection(overlay$$1),
        isSwiping: getIsSwiping(swiping$$1),
        isSwiped: getIsSwiped(swiping$$1),
        isVerticalSwipe: getIsVertical(swiping$$1)
    };
}, { swipe: swipe }), _dec$3(_class$6 = (_temp2$5 = _class2$3 = function (_PureComponent) {
    inherits(Changer, _PureComponent);

    function Changer() {
        var _ref2;

        var _temp, _this, _ret;

        classCallCheck(this, Changer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref2 = Changer.__proto__ || Object.getPrototypeOf(Changer)).call.apply(_ref2, [this].concat(args))), _this), _this.swipeDelay = null, _this.isSwipeBack = false, _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(Changer, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var _this2 = this;

            var _props = this.props,
                gif = _props.gif,
                isSwiped = _props.isSwiped;

            if (prevProps.gif !== gif) {
                this.resetSwipe();
            }
            if (isSwiped && prevProps.isSwiped !== isSwiped) {
                clearTimeout(this.swipeDelay);
                this.swipeDelay = setTimeout(function () {
                    return _this2.onSwipeComplete();
                }, SWIPE_DURATION);
            }
        }
    }, {
        key: 'resetSwipe',
        value: function resetSwipe$$1() {
            this.isSwipeCancel = false;
            this.props.swipe({ isReset: true });
        }
    }, {
        key: 'onSwiping',
        value: function onSwiping(x) {
            var _props2 = this.props,
                nextGif = _props2.nextGif,
                previousGif = _props2.previousGif,
                width = _props2.width,
                swipe$$1 = _props2.swipe;


            this.isSwipeBack = x > 0;
            swipe$$1({
                x: x / width,
                y: 0,
                preview: getPreview(this.isSwipeBack ? previousGif : nextGif)
            });
            clearTimeout(this.swipeDelay);
        }
    }, {
        key: 'onSwipingUp',
        value: function onSwipingUp(y) {
            var _props3 = this.props,
                availableChannels = _props3.availableChannels,
                height = _props3.height,
                currentChannelIndex = _props3.currentChannelIndex,
                swipe$$1 = _props3.swipe;

            var hasChannels = availableChannels && availableChannels.length > 1;
            var nextChannel = null;
            clearTimeout(this.swipeDelay);
            this.isSwipeBack = y > 0;

            if (hasChannels && !isNaN(currentChannelIndex)) {
                var direction = this.isSwipeBack ? -1 : 1;
                var total = availableChannels.length;
                var nextIndex = (currentChannelIndex + direction) % total;
                nextChannel = availableChannels[nextIndex < 0 ? total - 1 : nextIndex];
            }

            swipe$$1({
                x: 0,
                y: hasChannels ? y / height : 0,
                preview: nextChannel ? TV_BARS : '',
                previewLabel: nextChannel ? nextChannel.displayName : ''
            });
        }
    }, {
        key: 'onSwiped',
        value: function onSwiped(deltaX, deltaY, isFlick) {
            var _props4 = this.props,
                availableChannels = _props4.availableChannels,
                width = _props4.width,
                height = _props4.height,
                previousGif = _props4.previousGif,
                isVerticalSwipe = _props4.isVerticalSwipe,
                swipe$$1 = _props4.swipe;

            var isSwipe = !!isFlick;
            var x = 0;
            var y = 0;

            if (isVerticalSwipe) {
                var hasChannels = availableChannels && availableChannels.length > 1;
                isSwipe = !hasChannels ? false : isSwipe || Math.abs(deltaY) >= height / 2;
                y = isSwipe ? this.isSwipeBack ? 1 : -1 : 0;
            } else {
                isSwipe = isSwipe || Math.abs(deltaX) >= width / 2;
                isSwipe = this.isSwipeBack && !previousGif ? false : isSwipe;
                x = isSwipe ? this.isSwipeBack ? 1 : -1 : 0;
            }
            this.isSwipeCancel = !isSwipe;
            swipe$$1({
                x: x,
                y: y,
                isSwiped: true
            });
        }
    }, {
        key: 'onSwipeComplete',
        value: function onSwipeComplete() {
            var _props5 = this.props,
                changeChannel$$1 = _props5.changeChannel,
                changeGif$$1 = _props5.changeGif,
                isVerticalSwipe = _props5.isVerticalSwipe;


            if (this.isSwipeCancel) {
                this.resetSwipe();
            } else if (isVerticalSwipe) {
                changeChannel$$1(this.isSwipeBack);
            } else {
                changeGif$$1(this.isSwipeBack);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props6 = this.props,
                children = _props6.children,
                isSubsection = _props6.isSubsection,
                isSwiping = _props6.isSwiping,
                isSwiped = _props6.isSwiped,
                onTap = _props6.onTap;

            return React.createElement(
                Swipeable,
                {
                    innerRef: function innerRef(c) {
                        return _this3.container = c;
                    },
                    className: css$13.container,
                    disabled: isSwiped || isSubsection,
                    preventDefaultTouchmoveEvent: true,
                    stopPropagation: true,
                    onSwipingLeft: function onSwipingLeft(e, x) {
                        return _this3.onSwiping(-x);
                    },
                    onSwipingRight: function onSwipingRight(e, x) {
                        return _this3.onSwiping(x);
                    },
                    onSwipingUp: function onSwipingUp(e, y) {
                        return _this3.onSwipingUp(-y);
                    },
                    onSwipingDown: function onSwipingDown(e, y) {
                        return _this3.onSwipingUp(y);
                    },
                    onSwiped: function onSwiped(e, x, y, isFlick) {
                        return _this3.onSwiped(x, y, isFlick);
                    },
                    onTap: onTap
                },
                children,
                isSwiping && React.createElement(Peeker$1, null)
            );
        }
    }]);
    return Changer;
}(PureComponent), _class2$3.propTypes = {
    children: PropTypes.node,
    gif: gifProps,
    nextGif: gifProps,
    previousGif: gifProps,
    width: PropTypes.number,
    height: PropTypes.number,
    availableChannels: PropTypes.array,
    currentChannelIndex: PropTypes.number,
    isVerticalSwipe: PropTypes.bool,
    isSubsection: PropTypes.bool,
    isSwiping: PropTypes.bool,
    isSwiped: PropTypes.bool,
    swipe: PropTypes.func.isRequired,
    onTap: PropTypes.func
}, _temp2$5)) || _class$6);

var css$14 = __$styleInject("._logo_1cew5_1 {\r\n    bottom: 20px;\r\n    height: 24px;\r\n    opacity: 0.3;\r\n    pointer-events: none;\r\n    position: absolute;\r\n    right: 22px;\r\n    -webkit-transition: opacity .25s ease-out, -webkit-transform .25s ease-out;\r\n    transition: opacity .25s ease-out, -webkit-transform .25s ease-out;\r\n    transition: opacity .25s ease-out, transform .25s ease-out;\r\n    transition: opacity .25s ease-out, transform .25s ease-out, -webkit-transform .25s ease-out;\r\n    width: auto;\r\n}\r\n\r\n    ._logo_1cew5_1[data-hidden=\"true\"] {\r\n        opacity: 0;\r\n        -webkit-transform: translateY(100%);\r\n                transform: translateY(100%);\r\n    }", { "logo": "_logo_1cew5_1" });

var Logo = (function (_ref) {
    var isHidden = _ref.isHidden;
    return React.createElement(
        "svg",
        { className: css$14.logo, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 73 17", "data-hidden": isHidden },
        React.createElement("path", {
            fill: "#FFF",
            fillRule: "evenodd",
            d: "M14.598 2.823C12.574.777 10.682.337 8.548.337 2.762.337.122 4.473.122 8.5c0 4.025 2.31 8.095 8.404 8.095 2.97 0 5.654-1.056 6.622-3.014V6.74H7.624v3.41h3.894v1.98c-.88.637-2.156.79-2.97.79-3.102 0-4.136-2.44-4.136-4.42 0-3.015 1.628-4.51 4.136-4.51 1.034 0 2.398.285 3.52 1.34l2.53-2.507zm7.348 13.354V.777h-4.334v15.4h4.334zm7.48-11.66v3.828h3.124c1.21 0 1.826-.88 1.826-1.892s-.638-1.936-1.826-1.936h-3.124zm3.124 7.502h-3.124v4.157H25.07V.777h7.48c4.136 0 6.182 2.596 6.182 5.61 0 3.146-2.068 5.588-6.182 5.632zm22.33 4.18V.8h-4.312v5.85h-5.544V.8h-4.356v15.4h4.356v-5.83h5.544v5.83h4.312zM61.216.776H56.31v.176l5.852 9.086v6.137h4.356V10.04L72.634.974V.777h-4.906l-3.322 5.28-3.19-5.28z"
        })
    );
});

function _applyDecoratedDescriptor$1(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

var changer = (function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        useMouse: true
    };
    return function (superclass) {
        var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp2;

        return _dec = connect(function (_ref) {
            var gifs$$1 = _ref.gifs,
                channels$$1 = _ref.channels;
            return {
                availableChannels: getChannels(channels$$1),
                currentIndex: getCurrentIndex(gifs$$1),
                currentChannelIndex: getCurrentChannelIndex(channels$$1),
                totalGifs: getTotalGifs(gifs$$1)
            };
        }, { changeGif: changeGif, changeChannel: changeChannel }), _dec2 = Debounce(80), _dec3 = Debounce(80), _dec(_class = (_class2 = (_temp2 = _class3 = function (_superclass) {
            inherits(_class2, _superclass);

            function _class2() {
                var _ref2;

                var _temp, _this, _ret;

                classCallCheck(this, _class2);

                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref2 = _class2.__proto__ || Object.getPrototypeOf(_class2)).call.apply(_ref2, [this].concat(args))), _this), _this.queuedGifIndex = 0, _this.queuedChannelIndex = 0, _temp), possibleConstructorReturn(_this, _ret);
            }

            createClass(_class2, [{
                key: 'componentDidMount',
                value: function componentDidMount() {
                    var _this2 = this;

                    if (options.useMouse) {
                        Mousetrap.bind('right', function () {
                            return _this2.queueNextGifIndex();
                        });
                        Mousetrap.bind('left', function () {
                            return _this2.queueNextGifIndex(true);
                        });
                    }
                    window && window.focus();
                    get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'componentDidMount', this) && get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'componentDidMount', this).call(this);
                }
            }, {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    if (options.useMouse) {
                        Mousetrap.unbind(['right', 'left', 'up', 'down']);
                    }
                    get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'componentWillUnmount', this) && get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'componentWillUnmount', this).call(this);
                }
            }, {
                key: 'componentDidUpdate',
                value: function componentDidUpdate(prevProps) {
                    var _this3 = this;

                    var _props = this.props,
                        currentIndex = _props.currentIndex,
                        currentChannelIndex = _props.currentChannelIndex,
                        availableChannels = _props.availableChannels;

                    if (currentIndex !== prevProps.currentIndex) {
                        this.queuedGifIndex = currentIndex;
                    }
                    if (currentChannelIndex !== prevProps.currentChannelIndex) {
                        this.queuedChannelIndex = currentChannelIndex;
                    }
                    if (options.useMouse && availableChannels !== prevProps.availableChannels) {
                        Mousetrap.unbind(['up', 'down']);
                        if (availableChannels.length > 1) {
                            Mousetrap.bind('up', function () {
                                return _this3.queueNextChannelIndex();
                            });
                            Mousetrap.bind('down', function () {
                                return _this3.queueNextChannelIndex(true);
                            });
                        }
                    }
                    get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'componentDidUpdate', this) && get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'componentDidUpdate', this).call(this, prevProps);
                }
            }, {
                key: 'queueNextGifIndex',
                value: function queueNextGifIndex() {
                    var isBack = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

                    this.queuedGifIndex += isBack ? -1 : 1;
                    this.queuedGifIndex = Math.max(0, this.queuedGifIndex);
                    this.setNextGifIndex();
                }
            }, {
                key: 'queueNextChannelIndex',
                value: function queueNextChannelIndex() {
                    var isBack = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                    var availableChannels = this.props.availableChannels;

                    this.queuedChannelIndex += isBack ? -1 : 1;
                    this.queuedChannelIndex = this.queuedChannelIndex % availableChannels.length;
                    if (this.queuedChannelIndex < 0) {
                        this.queuedChannelIndex = availableChannels.length - 1;
                    }
                    this.setNextChannelIndex();
                }
            }, {
                key: 'setNextGifIndex',
                value: function setNextGifIndex() {
                    this.props.changeGif(this.queuedGifIndex);
                }
            }, {
                key: 'setNextChannelIndex',
                value: function setNextChannelIndex() {
                    this.props.changeChannel(this.queuedChannelIndex);
                }
            }]);
            return _class2;
        }(superclass), _class3.propTypes = {
            currentIndex: PropTypes.number,
            changeGif: PropTypes.func.isRequired,
            changeChannel: PropTypes.func.isRequired,
            currentChannelIndex: PropTypes.number,
            totalGifs: PropTypes.number
        }, _temp2), _applyDecoratedDescriptor$1(_class2.prototype, 'setNextGifIndex', [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, 'setNextGifIndex'), _class2.prototype), _applyDecoratedDescriptor$1(_class2.prototype, 'setNextChannelIndex', [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, 'setNextChannelIndex'), _class2.prototype), _class2)) || _class;
    };
});

var css$15 = __$styleInject("._container_1gkfw_1 {\r\n    border: 0;\r\n    color: #fff;\r\n    display: block;\r\n    font-family: \"interface\", sans-serif;\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n    height: 100%;\r\n    margin: 0;\r\n    overflow: hidden;\r\n    padding: 0;\r\n    position: relative;\r\n    text-align: left;\r\n    vertical-align: baseline;\r\n    width: 100%;\r\n    z-index: 1;\r\n}\r\n\r\n    ._container_1gkfw_1 div, ._container_1gkfw_1 span, ._container_1gkfw_1 object, ._container_1gkfw_1 iframe, ._container_1gkfw_1 h1, ._container_1gkfw_1 h2, ._container_1gkfw_1 h3, ._container_1gkfw_1 h4, ._container_1gkfw_1 h5, ._container_1gkfw_1 h6, ._container_1gkfw_1 p, ._container_1gkfw_1 blockquote, ._container_1gkfw_1 pre, ._container_1gkfw_1 abbr, ._container_1gkfw_1 address, ._container_1gkfw_1 cite, ._container_1gkfw_1 code, ._container_1gkfw_1 del, ._container_1gkfw_1 dfn, ._container_1gkfw_1 em, ._container_1gkfw_1 img, ._container_1gkfw_1 ins, ._container_1gkfw_1 kbd, ._container_1gkfw_1 q, ._container_1gkfw_1 samp, ._container_1gkfw_1 small, ._container_1gkfw_1 strong, ._container_1gkfw_1 sub, ._container_1gkfw_1 sup, ._container_1gkfw_1 var, ._container_1gkfw_1 b, ._container_1gkfw_1 i, ._container_1gkfw_1 dl, ._container_1gkfw_1 dt, ._container_1gkfw_1 dd, ._container_1gkfw_1 ol, ._container_1gkfw_1 ul, ._container_1gkfw_1 li, ._container_1gkfw_1 fieldset, ._container_1gkfw_1 form, ._container_1gkfw_1 label, ._container_1gkfw_1 legend, ._container_1gkfw_1 table, ._container_1gkfw_1 caption, ._container_1gkfw_1 tbody, ._container_1gkfw_1 tfoot, ._container_1gkfw_1 thead, ._container_1gkfw_1 tr, ._container_1gkfw_1 th, ._container_1gkfw_1 td, ._container_1gkfw_1 canvas, ._container_1gkfw_1 audio, ._container_1gkfw_1 video {\r\n        border: 0;\r\n        -webkit-font-smoothing: antialiased;\r\n        -moz-osx-font-smoothing: grayscale;\r\n    }\r\n\r\n    ._container_1gkfw_1:-webkit-fullscreen,\r\n    ._container_1gkfw_1:-moz-fullscreen,\r\n    ._container_1gkfw_1:-webkit-full-screen {\r\n        height: 100%;\r\n        width: 100%;\r\n    }\r\n\r\n    ._container_1gkfw_1:-webkit-fullscreen ._cutout_1gkfw_69, ._container_1gkfw_1:-moz-fullscreen ._cutout_1gkfw_69, ._container_1gkfw_1:-webkit-full-screen ._cutout_1gkfw_69 {\r\n            display: none;\r\n        }\r\n\r\n    ._container_1gkfw_1:-webkit-fullscreen ._wrapper_1gkfw_77, ._container_1gkfw_1:-moz-fullscreen ._wrapper_1gkfw_77, ._container_1gkfw_1:-webkit-full-screen ._wrapper_1gkfw_77 {\r\n            -webkit-clip-path: none !important;\r\n                    clip-path: none !important;\r\n        }\r\n\r\n    ._container_1gkfw_1:-webkit-fullscreen,\r\n    ._container_1gkfw_1:-moz-fullscreen,\r\n    ._container_1gkfw_1:fullscreen {\r\n        height: 100%;\r\n        width: 100%;\r\n    }\r\n\r\n    ._container_1gkfw_1:-webkit-fullscreen ._cutout_1gkfw_69, ._container_1gkfw_1:-moz-fullscreen ._cutout_1gkfw_69, ._container_1gkfw_1:fullscreen ._cutout_1gkfw_69 {\r\n            display: none;\r\n        }\r\n\r\n    ._container_1gkfw_1:-webkit-fullscreen ._wrapper_1gkfw_77, ._container_1gkfw_1:-moz-fullscreen ._wrapper_1gkfw_77, ._container_1gkfw_1:fullscreen ._wrapper_1gkfw_77 {\r\n            -webkit-clip-path: none !important;\r\n                    clip-path: none !important;\r\n        }\r\n\r\n    ._container_1gkfw_1 div[data-swiped=\"true\"] {\r\n        -webkit-transition: all .2s ease-out;\r\n        transition: all .2s ease-out;\r\n    }\r\n\r\n._tvStatic_1gkfw_97 {\r\n    background: no-repeat url('https://media.giphy.com/media/Yqn9tE2E00k4U/200.gif') center center;\r\n    background-size: cover;\r\n    height: 100%;\r\n    left: 0;\r\n    position: absolute;\r\n    top: 0;\r\n    width: 100%;\r\n}\r\n\r\n._wrapper_1gkfw_77 {\r\n    background: #000;\r\n    height: 100%;\r\n    position: relative;\r\n    width: 100%;\r\n}\r\n._wrapperClipped_1gkfw_129 {\r\n    overflow: hidden;\r\n}\r\n\r\n._cutout_1gkfw_69 {\r\n    -webkit-box-shadow: 16px 16px 0 #ff6666,\r\n        16px 32px 0 #ff6666,\r\n        32px 32px 0 #ff6666,\r\n        16px 48px 0 #ff6666,\r\n        32px 48px 0 #ff6666,\r\n        48px 48px 0 #ff6666;\r\n            box-shadow: 16px 16px 0 #ff6666,\r\n        16px 32px 0 #ff6666,\r\n        32px 32px 0 #ff6666,\r\n        16px 48px 0 #ff6666,\r\n        32px 48px 0 #ff6666,\r\n        48px 48px 0 #ff6666;\r\n    height: 16px;\r\n    position: absolute;\r\n    right: 0;\r\n    top: -64px;\r\n    width: 16px;\r\n    z-index: 11;\r\n    -webkit-transform: translate(-48px, 48px);\r\n            transform: translate(-48px, 48px);\r\n    -webkit-transition: -webkit-transform .25s ease-out;\r\n    transition: -webkit-transform .25s ease-out;\r\n    transition: transform .25s ease-out;\r\n    transition: transform .25s ease-out, -webkit-transform .25s ease-out;\r\n}\r\n\r\n._cutout_1gkfw_69[data-hidden=\"true\"] {\r\n        -webkit-transform: translate(0, 0);\r\n                transform: translate(0, 0);\r\n    }\r\n._cutoutHit_1gkfw_179 {\r\n    cursor: pointer;\r\n    height: 48px;\r\n    left: 16px;\r\n    position: absolute;\r\n    top: 16px;\r\n    width: 48px;\r\n}", { "container": "_container_1gkfw_1", "cutout": "_cutout_1gkfw_69", "wrapper": "_wrapper_1gkfw_77", "tvStatic": "_tvStatic_1gkfw_97", "wrapperClipped": "_wrapperClipped_1gkfw_129 _wrapper_1gkfw_77", "cutoutHit": "_cutoutHit_1gkfw_179" });

var _dec;
var _dec2;
var _dec3;
var _class$1;
var _class2;
var _class3;
var _temp2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

var HEADER_HEIGHT = parseInt(headerHeight$1);
var FOOTER_HEIGHT = parseInt(footerHeight);
var MOUSE_DELAY = 2000;

var getCutoutStyle = function getCutoutStyle(width, height) {
    var clipPath = 'polygon(-2px -2px, ' + (width - 40) + 'px -2px, ' + (width - 40) + 'px 40px, ' + (width + 2) + 'px 40px, ' + (width + 2) + 'px ' + (height + 2) + 'px, -2px ' + (height + 2) + 'px, -2px -2px)';
    return {
        WebkitClipPath: clipPath,
        clipPath: clipPath
    };
};

var TV = (_dec = connect(function (_ref) {
    var channels$$1 = _ref.channels,
        gifs$$1 = _ref.gifs,
        overlay$$1 = _ref.overlay,
        options$$1 = _ref.options,
        dimensions$$1 = _ref.dimensions,
        swiping$$1 = _ref.swiping;
    return {
        gif: getCurrentGif(gifs$$1),
        channel: getCurrentChannel(channels$$1),
        height: getHeight(dimensions$$1),
        width: getWidth(dimensions$$1),
        isCutoutHidden: getIsCutoutHidden(options$$1),
        isLogoHidden: getIsLogoHidden(options$$1),
        isSwiping: getIsSwiping(swiping$$1),
        isFullscreen: getIsFullscreen(overlay$$1),
        isOverlay: getIsOverlayOn(overlay$$1),
        isOverlaySubsection: getIsSubsection(overlay$$1)
    };
}, { setDimensions: setDimensions, setIsOverlayOn: setIsOverlayOn, setIsFullscreen: setIsFullscreen }), _dec2 = changer(), _dec3 = Throttle(50), _dec(_class$1 = _dec2(_class$1 = (_class2 = (_temp2 = _class3 = function (_PureComponent) {
    inherits(TV, _PureComponent);

    function TV() {
        var _ref2;

        var _temp, _this, _ret;

        classCallCheck(this, TV);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref2 = TV.__proto__ || Object.getPrototypeOf(TV)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
            isCutout: false
        }, _this.tapTime = null, _this.cutoutDelay = null, _this.overlayDelay = null, _this.onResize = _this.updateDimensions.bind(_this), _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(TV, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.updateDimensions();

            // events
            if (window) {
                window.addEventListener('resize', this.onResize, false);
                window.focus();
            }

            // document events
            if (document) {
                document.onfullscreenchange = document.onwebkitfullscreenchange = document.onmozfullscreenchange = function () {
                    var isFullscreen = document.fullscreen || document.webkitIsFullScreen || document.mozFullScreen;
                    if (isFullscreen !== _this2.props.isFullscreen) {
                        _this2.props.setIsFullscreen(isFullscreen);
                    }
                };
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var _this3 = this;

            var _props = this.props,
                channel = _props.channel,
                isFullscreen = _props.isFullscreen,
                isOverlay = _props.isOverlay,
                isCutoutHidden = _props.isCutoutHidden;

            // show/hide cutout when overlay is shown/hidden

            if (!isCutoutHidden && isOverlay !== prevProps.isOverlay) {
                clearTimeout(this.cutoutDelay);
                this.cutoutDelay = setTimeout(function () {
                    _this3.setState({ isCutout: isOverlay });
                }, isOverlay ? 110 : 30);
            }

            // show overlay when channel changes
            if (channel !== prevProps.channel) {
                this.showOverlay();
            }

            // toggle fullscreen
            if (isFullscreen !== prevProps.isFullscreen) {
                this.toggleFullscreen();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window && window.removeEventListener('resize', this.onResize, false);
            document.onfullscreenchange = document.onwebkitfullscreenchange = document.onmozfullscreenchange = null;
            clearTimeout(this.cutoutDelay);
            clearTimeout(this.overlayDelay);
        }
    }, {
        key: 'updateDimensions',
        value: function updateDimensions() {
            this.props.setDimensions({
                width: this.el.offsetWidth,
                height: this.el.offsetHeight
            });
        }
    }, {
        key: 'toggleFullscreen',
        value: function toggleFullscreen() {
            var isFullscreen = this.props.isFullscreen;

            if (isFullscreen) {
                var fullscreen = this.el.requestFullscreen || this.el.webkitRequestFullScreen || this.el.mozRequestFullScreen;
                fullscreen && fullscreen.call(this.el);
            } else {
                var cancel = document.exitFullscreen || document.webkitExitFullscreen || document.mozCancelFullScreen;
                cancel && cancel.call(document);
            }
        }
    }, {
        key: 'showOverlay',
        value: function showOverlay() {
            var _this4 = this;

            var _props2 = this.props,
                isOverlay = _props2.isOverlay,
                setIsOverlayOn$$1 = _props2.setIsOverlayOn;

            !isOverlay && setIsOverlayOn$$1(true);
            clearTimeout(this.overlayDelay);
            this.overlayDelay = setTimeout(function () {
                return _this4.hideOverlay();
            }, MOUSE_DELAY);
        }
    }, {
        key: 'hideOverlay',
        value: function hideOverlay() {
            var _props3 = this.props,
                isOverlaySubsection = _props3.isOverlaySubsection,
                setIsOverlayOn$$1 = _props3.setIsOverlayOn;

            clearTimeout(this.overlayDelay);
            !isOverlaySubsection && setIsOverlayOn$$1(false);
        }
    }, {
        key: 'popOut',
        value: function popOut() {
            var channel = this.props.channel;

            var windowX = window.screenX || 0;
            var windowY = window.screenY || 0;

            var _el$getBoundingClient = this.el.getBoundingClientRect(),
                left = _el$getBoundingClient.left,
                top = _el$getBoundingClient.top,
                height = _el$getBoundingClient.height,
                width = _el$getBoundingClient.width;

            // if the popout is going to be too big,
            // ignore the placement matching and open
            // the popout smaller and 16:9


            if (width > 600) {
                width = 600;
                height = 338;
                left = windowX = 0;
                top = windowY = 0;
            }

            openPopup(channel.popoutUrl, null, width, height, windowX + left, windowY + top);
        }
    }, {
        key: 'checkMousePosition',
        value: function checkMousePosition(_ref3) {
            var pageX = _ref3.pageX,
                pageY = _ref3.pageY;
            var _props4 = this.props,
                height = _props4.height,
                width = _props4.width;

            var _el$getBoundingClient2 = this.el.getBoundingClientRect(),
                left = _el$getBoundingClient2.left,
                top = _el$getBoundingClient2.top;

            var mouseX = pageX - left - getScrollLeft();
            var mouseY = pageY - top - getScrollTop();
            var isMouseOut = mouseX < 0 || mouseX > width || mouseY < 0 || mouseY > height;

            // i'm having to do a mouseout check in here because
            // the mouseleave event was triggering when
            // tapping/clicking the next/previous buttons.
            // not totally sure why it was happening...
            // but this fixes it for now.
            if (isMouseOut) {
                this.hideOverlay();
            } else {
                this.showOverlay();

                // keep overlay open when mousing over the
                // footer or header areas of the overlay
                if (mouseY <= HEADER_HEIGHT || mouseY >= height - FOOTER_HEIGHT) {
                    clearTimeout(this.overlayDelay);
                }
            }
        }
    }, {
        key: 'onMouseMove',
        value: function onMouseMove(e) {
            e.persist();
            this.checkMousePosition(e);
        }
    }, {
        key: 'onTap',
        value: function onTap(e) {
            var _props5 = this.props,
                setIsOverlayOn$$1 = _props5.setIsOverlayOn,
                isOverlay = _props5.isOverlay;

            if (e.target.dataset && e.target.dataset.tap === 'true') {
                e.preventDefault();
                e.stopPropagation();
                isOverlay ? setIsOverlayOn$$1(false) : this.showOverlay();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            var _props6 = this.props,
                gif = _props6.gif,
                height = _props6.height,
                width = _props6.width,
                isOverlay = _props6.isOverlay,
                isOverlaySubsection = _props6.isOverlaySubsection,
                isCutoutHidden = _props6.isCutoutHidden,
                isLogoHidden = _props6.isLogoHidden;
            var isCutout = this.state.isCutout;

            var showCutout = isCutout && !isOverlaySubsection;
            var cutoutStyle = showCutout ? getCutoutStyle(width, height) : {};
            return React.createElement(
                'div',
                {
                    ref: function ref(c) {
                        return _this5.el = c;
                    },
                    className: css$15.container,
                    onMouseEnter: function onMouseEnter(e) {
                        return _this5.onMouseMove(e);
                    },
                    onMouseMove: function onMouseMove(e) {
                        return _this5.onMouseMove(e);
                    },
                    onMouseLeave: function onMouseLeave(e) {
                        return _this5.onMouseMove(e);
                    }
                },
                React.createElement(
                    Changer,
                    {
                        changeChannel: function changeChannel(isBack) {
                            return _this5.queueNextChannelIndex(isBack);
                        },
                        changeGif: function changeGif(isBack) {
                            return _this5.queueNextGifIndex(isBack);
                        },
                        onTap: function onTap(e) {
                            return _this5.onTap(e);
                        }
                    },
                    React.createElement(
                        'div',
                        { className: showCutout ? css$15.wrapperClipped : css$15.wrapper, 'data-tap': true, style: cutoutStyle },
                        gif ? React.createElement(Gif, { onViewed: function onViewed() {
                                return _this5.queueNextGifIndex();
                            } }) : React.createElement('div', { className: css$15.tvStatic }),
                        !isLogoHidden && React.createElement(Logo, { isHidden: isOverlay }),
                        React.createElement(Overlay$1, null)
                    )
                ),
                !isCutoutHidden && React.createElement(
                    'div',
                    { className: css$15.cutout, 'data-hidden': isOverlaySubsection || !isOverlay },
                    React.createElement('div', { className: css$15.cutoutHit, onClick: function onClick() {
                            return _this5.popOut();
                        } })
                )
            );
        }
    }]);
    return TV;
}(PureComponent), _class3.propTypes = {
    gif: gifProps,
    channel: PropTypes.object,
    height: PropTypes.number,
    width: PropTypes.number,
    isSwiping: PropTypes.bool,
    isOverlay: PropTypes.bool,
    isOverlaySubsection: PropTypes.bool,
    isCutoutHidden: PropTypes.bool,
    isLogoHidden: PropTypes.bool,
    isFullscreen: PropTypes.bool,
    setDimensions: PropTypes.func.isRequired,
    setIsOverlayOn: PropTypes.func.isRequired,
    setIsFullscreen: PropTypes.func.isRequired
}, _temp2), _applyDecoratedDescriptor(_class2.prototype, 'checkMousePosition', [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, 'checkMousePosition'), _class2.prototype), _class2)) || _class$1) || _class$1);

var _class;
var _temp;

var App = (_temp = _class = function (_PureComponent) {
    inherits(App, _PureComponent);

    function App() {
        classCallCheck(this, App);
        return possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
    }

    createClass(App, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _props = this.props,
                apiKey = _props.apiKey,
                letterbox = _props.letterbox,
                delay = _props.delay,
                random = _props.random,
                gifOffset = _props.gifOffset,
                gifs = _props.gifs,
                channels = _props.channels,
                hideCutout = _props.hideCutout,
                hideLogo = _props.hideLogo,
                forceGifs = _props.forceGifs;

            if (!apiKey) {
                return new Error('Must provide an API key');
            }

            // configure TV
            store.dispatch(setApiKey(apiKey));
            store.dispatch(setIsLetterbox(letterbox));
            delay && store.dispatch(setGifDelay(delay));
            random && store.dispatch(setIsRandom(random));
            gifOffset && store.dispatch(setGifOffset(gifOffset));
            hideCutout && store.dispatch(setIsCutoutHidden(true));
            hideLogo && store.dispatch(setIsLogoHidden(true));
            forceGifs && store.dispatch(setIsForceGifs(true));

            if (gifs && gifs.length) {
                store.dispatch(programGifs(gifs));
            } else if (channels && channels.length) {
                store.dispatch(programChannels(channels));
            } else {
                store.dispatch(programChannels([682]));
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var isOffscreen = this.props.isOffscreen;

            return React.createElement(
                Provider,
                { store: store },
                isOffscreen ? React.createElement('div', null) : React.createElement(TV, null)
            );
        }
    }]);
    return App;
}(PureComponent), _class.propTypes = {
    apiKey: PropTypes.string.isRequired,
    channels: PropTypes.array,
    gifs: PropTypes.arrayOf(PropTypes.string),
    delay: PropTypes.number,
    letterbox: PropTypes.bool,
    random: PropTypes.bool,
    hideCutout: PropTypes.bool,
    hideLogo: PropTypes.bool,
    gifOffset: PropTypes.number,
    forceGifs: PropTypes.bool,
    isOffscreen: PropTypes.bool
}, _class.defaultProps = {
    letterbox: true,
    random: false,
    hideCutout: false,
    hideLogo: false,
    forceGifs: false,
    isOffscreen: false
}, _temp);

export default App;
